import {
  AnalyticsPluginIdentifier,
  AppInsightsCore,
  BaseCore,
  BaseTelemetryPlugin,
  BreezeChannelIdentifier,
  ConfigurationManager,
  ConnectionStringParser,
  ContextTagKeys,
  CoreUtils,
  CorrelationIdHelper,
  CtxTagKeys,
  DEFAULT_BREEZE_ENDPOINT,
  DEFAULT_BREEZE_PATH,
  Data,
  DataSanitizer,
  DateTimeUtils,
  DisabledPropertyName,
  DistributedTracingModes,
  Envelope,
  Event as Event2,
  Exception,
  Extensions,
  HttpMethod,
  InstrumentEvent,
  InstrumentFunc,
  InstrumentProto,
  LoggingSeverity,
  Metric,
  NotificationManager,
  PageView,
  PageViewPerformance,
  PerfEvent,
  PerfManager,
  ProcessLegacy,
  PropertiesPluginIdentifier,
  RemoteDependencyData,
  RequestHeaders,
  SampleRate,
  SeverityLevel,
  TelemetryItemCreator,
  Trace,
  UrlHelper,
  Util,
  _InternalLogMessage,
  _InternalMessageId,
  __assignFn,
  __extendsFn,
  _legacyCookieMgr,
  _logInternalMessage,
  _throwInternal,
  _warnToConsole,
  addPageHideEventListener,
  addPageUnloadEventListener,
  arrForEach,
  arrIndexOf,
  createDistributedTraceContextFromTrace,
  createDomEvent,
  createProcessTelemetryContext,
  createTelemetryItem,
  createTraceParent,
  createUniqueNamespace,
  dataSanitizeString,
  dataSanitizeUrl,
  dateNow,
  dateTimeUtilsDuration,
  dateTimeUtilsNow,
  deepFreeze,
  doPerf,
  dumpObj,
  dynamicProto,
  eventOff,
  eventOn,
  formatTraceParent,
  generateW3CId,
  getDocument,
  getExceptionName,
  getGlobal,
  getHistory,
  getIEVersion,
  getJSON,
  getLocation,
  getNavigator,
  getPerformance,
  getSetValue,
  getWindow,
  hasDocument,
  hasHistory,
  hasJSON,
  hasWindow,
  isArray,
  isBeaconsSupported,
  isCrossOriginError,
  isFetchSupported,
  isFunction,
  isInternalApplicationInsightsEndpoint,
  isNullOrUndefined,
  isNumber,
  isObject,
  isReactNative,
  isString,
  isTruthy,
  isUndefined,
  isXhrSupported,
  mergeEvtNamespace,
  msToTimeSpan,
  newId,
  normalizeJsName,
  objDefineAccessors,
  objForEachKey,
  objKeys,
  optimizeObject,
  parseConnectionString,
  proxyAssign,
  proxyFunctions,
  removePageHideEventListener,
  removePageUnloadEventListener,
  safeGetCookieMgr,
  safeGetLogger,
  setValue,
  strNotSpecified,
  strShimPrototype,
  strShimUndefined,
  strTrim,
  stringToBoolOrDefault,
  throwError,
  toISOString,
  urlGetAbsoluteUrl,
  urlGetCompleteUrl,
  useXDomainRequest,
  utlCanUseLocalStorage,
  utlCanUseSessionStorage,
  utlDisableStorage,
  utlEnableStorage,
  utlGetLocalStorage,
  utlGetSessionStorage,
  utlRemoveSessionStorage,
  utlRemoveStorage,
  utlSetLocalStorage,
  utlSetSessionStorage
} from "./chunk-QJXNZHKV.js";
import "./chunk-J43GMYXM.js";

// node_modules/.pnpm/@microsoft+applicationinsights-analytics-js@2.8.8/node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/__DynamicConstants.js
var _DYN_TO_STRING = "toString";
var _DYN_DISABLE_EXCEPTION_TR0 = "disableExceptionTracking";
var _DYN_AUTO_TRACK_PAGE_VISI1 = "autoTrackPageVisitTime";
var _DYN_OVERRIDE_PAGE_VIEW_D2 = "overridePageViewDuration";
var _DYN_ENABLE_UNHANDLED_PRO3 = "enableUnhandledPromiseRejectionTracking";
var _DYN_SAMPLING_PERCENTAGE = "samplingPercentage";
var _DYN_IS_STORAGE_USE_DISAB4 = "isStorageUseDisabled";
var _DYN_IS_BROWSER_LINK_TRAC5 = "isBrowserLinkTrackingEnabled";
var _DYN_ENABLE_AUTO_ROUTE_TR6 = "enableAutoRouteTracking";
var _DYN_NAME_PREFIX = "namePrefix";
var _DYN_DISABLE_FLUSH_ON_BEF7 = "disableFlushOnBeforeUnload";
var _DYN_CORE = "core";
var _DYN_DATA_TYPE = "dataType";
var _DYN_ENVELOPE_TYPE = "envelopeType";
var _DYN_DIAG_LOG = "diagLog";
var _DYN_TRACK = "track";
var _DYN_TRACK_PAGE_VIEW = "trackPageView";
var _DYN_TRACK_PREVIOUS_PAGE_9 = "trackPreviousPageVisit";
var _DYN_SEND_PAGE_VIEW_INTER10 = "sendPageViewInternal";
var _DYN_SEND_PAGE_VIEW_PERFO11 = "sendPageViewPerformanceInternal";
var _DYN_POPULATE_PAGE_VIEW_P12 = "populatePageViewPerformanceEvent";
var _DYN_HREF = "href";
var _DYN_SEND_EXCEPTION_INTER13 = "sendExceptionInternal";
var _DYN_EXCEPTION = "exception";
var _DYN_ERROR = "error";
var _DYN__ONERROR = "_onerror";
var _DYN_ERROR_SRC = "errorSrc";
var _DYN_LINE_NUMBER = "lineNumber";
var _DYN_COLUMN_NUMBER = "columnNumber";
var _DYN_MESSAGE = "message";
var _DYN__CREATE_AUTO_EXCEPTI14 = "CreateAutoException";
var _DYN_ADD_TELEMETRY_INITIA15 = "addTelemetryInitializer";
var _DYN_DURATION = "duration";
var _DYN_LENGTH = "length";
var _DYN_IS_PERFORMANCE_TIMIN16 = "isPerformanceTimingSupported";
var _DYN_GET_PERFORMANCE_TIMI17 = "getPerformanceTiming";
var _DYN_NAVIGATION_START = "navigationStart";
var _DYN_SHOULD_COLLECT_DURAT18 = "shouldCollectDuration";
var _DYN_IS_PERFORMANCE_TIMIN19 = "isPerformanceTimingDataReady";
var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType";
var _DYN_RESPONSE_START = "responseStart";
var _DYN_REQUEST_START = "requestStart";
var _DYN_LOAD_EVENT_END = "loadEventEnd";
var _DYN_RESPONSE_END = "responseEnd";
var _DYN_CONNECT_END = "connectEnd";
var _DYN_PAGE_VISIT_START_TIM20 = "pageVisitStartTime";

// node_modules/.pnpm/@microsoft+applicationinsights-analytics-js@2.8.8/node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Telemetry/PageViewManager.js
var PageViewManager = function() {
  function PageViewManager2(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
    dynamicProto(PageViewManager2, this, function(_self) {
      var intervalHandle = null;
      var itemQueue = [];
      var pageViewPerformanceSent = false;
      var _logger;
      if (core) {
        _logger = core.logger;
      }
      function _flushChannels(isAsync) {
        if (core) {
          core.flush(isAsync);
        }
      }
      function _addQueue(cb) {
        itemQueue.push(cb);
        if (!intervalHandle) {
          intervalHandle = setInterval(function() {
            var allItems = itemQueue.slice(0);
            var doFlush = false;
            itemQueue = [];
            arrForEach(allItems, function(item) {
              if (!item()) {
                itemQueue.push(item);
              } else {
                doFlush = true;
              }
            });
            if (itemQueue[_DYN_LENGTH] === 0) {
              clearInterval(intervalHandle);
              intervalHandle = null;
            }
            if (doFlush) {
              _flushChannels(true);
            }
          }, 100);
        }
      }
      _self[_DYN_TRACK_PAGE_VIEW] = function(pageView, customProperties) {
        var name = pageView.name;
        if (isNullOrUndefined(name) || typeof name !== "string") {
          var doc = getDocument();
          name = pageView.name = doc && doc.title || "";
        }
        var uri = pageView.uri;
        if (isNullOrUndefined(uri) || typeof uri !== "string") {
          var location_1 = getLocation();
          uri = pageView.uri = location_1 && location_1[_DYN_HREF] || "";
        }
        if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN16]()) {
          appInsights[_DYN_SEND_PAGE_VIEW_INTER10](pageView, customProperties);
          _flushChannels(true);
          _throwInternal(_logger, 2, 25, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
          return;
        }
        var pageViewSent = false;
        var customDuration;
        var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI17]()[_DYN_NAVIGATION_START];
        if (start > 0) {
          customDuration = dateTimeUtilsDuration(start, +new Date());
          if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT18](customDuration)) {
            customDuration = void 0;
          }
        }
        var duration;
        if (!isNullOrUndefined(customProperties) && !isNullOrUndefined(customProperties[_DYN_DURATION])) {
          duration = customProperties[_DYN_DURATION];
        }
        if (overridePageViewDuration || !isNaN(duration)) {
          if (isNaN(duration)) {
            if (!customProperties) {
              customProperties = {};
            }
            customProperties[_DYN_DURATION] = customDuration;
          }
          appInsights[_DYN_SEND_PAGE_VIEW_INTER10](pageView, customProperties);
          _flushChannels(true);
          pageViewSent = true;
        }
        var maxDurationLimit = 6e4;
        if (!customProperties) {
          customProperties = {};
        }
        _addQueue(function() {
          var processed = false;
          try {
            if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN19]()) {
              processed = true;
              var pageViewPerformance = {
                name,
                uri
              };
              pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P12](pageViewPerformance);
              if (!pageViewPerformance.isValid && !pageViewSent) {
                customProperties[_DYN_DURATION] = customDuration;
                appInsights[_DYN_SEND_PAGE_VIEW_INTER10](pageView, customProperties);
              } else {
                if (!pageViewSent) {
                  customProperties[_DYN_DURATION] = pageViewPerformance.durationMs;
                  appInsights[_DYN_SEND_PAGE_VIEW_INTER10](pageView, customProperties);
                }
                if (!pageViewPerformanceSent) {
                  appInsights[_DYN_SEND_PAGE_VIEW_PERFO11](pageViewPerformance, customProperties);
                  pageViewPerformanceSent = true;
                }
              }
            } else if (start > 0 && dateTimeUtilsDuration(start, +new Date()) > maxDurationLimit) {
              processed = true;
              if (!pageViewSent) {
                customProperties[_DYN_DURATION] = maxDurationLimit;
                appInsights[_DYN_SEND_PAGE_VIEW_INTER10](pageView, customProperties);
              }
            }
          } catch (e) {
            _throwInternal(_logger, 1, 38, "trackPageView failed on page load calculation: " + getExceptionName(e), { exception: dumpObj(e) });
          }
          return processed;
        });
      };
      _self.teardown = function(unloadCtx, unloadState) {
        if (intervalHandle) {
          clearInterval(intervalHandle);
          intervalHandle = null;
          var allItems = itemQueue.slice(0);
          var doFlush_1 = false;
          itemQueue = [];
          arrForEach(allItems, function(item) {
            if (item()) {
              doFlush_1 = true;
            }
          });
        }
      };
    });
  }
  PageViewManager2.__ieDyn = 1;
  return PageViewManager2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-analytics-js@2.8.8/node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Telemetry/PageViewPerformanceManager.js
var MAX_DURATION_ALLOWED = 36e5;
var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function _isPerformanceTimingSupported() {
  var perf = getPerformance();
  return perf && !!perf.timing;
}
function _isPerformanceNavigationTimingSupported() {
  var perf = getPerformance();
  return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[_DYN_LENGTH] > 0;
}
function _isPerformanceTimingDataReady() {
  var perf = getPerformance();
  var timing = perf ? perf.timing : 0;
  return timing && timing.domainLookupStart > 0 && timing[_DYN_NAVIGATION_START] > 0 && timing[_DYN_RESPONSE_START] > 0 && timing[_DYN_REQUEST_START] > 0 && timing[_DYN_LOAD_EVENT_END] > 0 && timing[_DYN_RESPONSE_END] > 0 && timing[_DYN_CONNECT_END] > 0 && timing.domLoading > 0;
}
function _getPerformanceTiming() {
  if (_isPerformanceTimingSupported()) {
    return getPerformance().timing;
  }
  return null;
}
function _getPerformanceNavigationTiming() {
  if (_isPerformanceNavigationTimingSupported()) {
    return getPerformance()[_DYN_GET_ENTRIES_BY_TYPE]("navigation")[0];
  }
  return null;
}
function _shouldCollectDuration() {
  var durations = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    durations[_i] = arguments[_i];
  }
  var _navigator = getNavigator() || {};
  var userAgent = _navigator.userAgent;
  var isGoogleBot = false;
  if (userAgent) {
    for (var i = 0; i < botAgentNames[_DYN_LENGTH]; i++) {
      isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf(botAgentNames[i]) !== -1;
    }
  }
  if (isGoogleBot) {
    return false;
  } else {
    for (var i = 0; i < durations[_DYN_LENGTH]; i++) {
      if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
        return false;
      }
    }
  }
  return true;
}
var PageViewPerformanceManager = function() {
  function PageViewPerformanceManager2(core) {
    var _this = this;
    var _logger = safeGetLogger(core);
    dynamicProto(PageViewPerformanceManager2, this, function(_self) {
      _self[_DYN_POPULATE_PAGE_VIEW_P12] = function(pageViewPerformance) {
        pageViewPerformance.isValid = false;
        var navigationTiming = _getPerformanceNavigationTiming();
        var timing = _getPerformanceTiming();
        var total = 0;
        var network = 0;
        var request = 0;
        var response = 0;
        var dom = 0;
        if (navigationTiming || timing) {
          if (navigationTiming) {
            total = navigationTiming[_DYN_DURATION];
            network = navigationTiming.startTime === 0 ? navigationTiming[_DYN_CONNECT_END] : dateTimeUtilsDuration(navigationTiming.startTime, navigationTiming[_DYN_CONNECT_END]);
            request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START]);
            response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START], navigationTiming[_DYN_RESPONSE_END]);
            dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END]);
          } else {
            total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START], timing[_DYN_LOAD_EVENT_END]);
            network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START], timing[_DYN_CONNECT_END]);
            request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START]);
            response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START], timing[_DYN_RESPONSE_END]);
            dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END]);
          }
          if (total === 0) {
            _throwInternal(_logger, 2, 10, "error calculating page view performance.", { total, network, request, response, dom });
          } else if (!_this[_DYN_SHOULD_COLLECT_DURAT18](total, network, request, response, dom)) {
            _throwInternal(_logger, 2, 45, "Invalid page load duration value. Browser perf data won't be sent.", { total, network, request, response, dom });
          } else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
            _throwInternal(_logger, 2, 8, "client performance math error.", { total, network, request, response, dom });
          } else {
            pageViewPerformance.durationMs = total;
            pageViewPerformance.perfTotal = pageViewPerformance[_DYN_DURATION] = msToTimeSpan(total);
            pageViewPerformance.networkConnect = msToTimeSpan(network);
            pageViewPerformance.sentRequest = msToTimeSpan(request);
            pageViewPerformance.receivedResponse = msToTimeSpan(response);
            pageViewPerformance.domProcessing = msToTimeSpan(dom);
            pageViewPerformance.isValid = true;
          }
        }
      };
      _self[_DYN_GET_PERFORMANCE_TIMI17] = _getPerformanceTiming;
      _self[_DYN_IS_PERFORMANCE_TIMIN16] = _isPerformanceTimingSupported;
      _self[_DYN_IS_PERFORMANCE_TIMIN19] = _isPerformanceTimingDataReady;
      _self[_DYN_SHOULD_COLLECT_DURAT18] = _shouldCollectDuration;
    });
  }
  PageViewPerformanceManager2.__ieDyn = 1;
  return PageViewPerformanceManager2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-analytics-js@2.8.8/node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Telemetry/PageVisitTimeManager.js
var PageVisitTimeManager = function() {
  function PageVisitTimeManager2(logger, pageVisitTimeTrackingHandler) {
    var prevPageVisitDataKeyName = "prevPageVisitData";
    dynamicProto(PageVisitTimeManager2, this, function(_self) {
      _self[_DYN_TRACK_PREVIOUS_PAGE_9] = function(currentPageName, currentPageUrl) {
        try {
          var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
          if (prevPageVisitTimeData) {
            pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
          }
        } catch (e) {
          _warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + dumpObj(e));
        }
      };
      function restartPageVisitTimer(pageName, pageUrl) {
        var prevPageVisitData = null;
        try {
          prevPageVisitData = stopPageVisitTimer();
          startPageVisitTimer(pageName, pageUrl);
        } catch (e) {
          _warnToConsole(logger, "Call to restart failed: " + dumpObj(e));
          prevPageVisitData = null;
        }
        return prevPageVisitData;
      }
      function startPageVisitTimer(pageName, pageUrl) {
        try {
          if (utlCanUseSessionStorage()) {
            if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) {
              throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
            }
            var currPageVisitData = new PageVisitData(pageName, pageUrl);
            var currPageVisitDataStr = getJSON().stringify(currPageVisitData);
            utlSetSessionStorage(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
          }
        } catch (e) {
          _warnToConsole(logger, "Call to start failed: " + dumpObj(e));
        }
      }
      function stopPageVisitTimer() {
        var prevPageVisitData = null;
        try {
          if (utlCanUseSessionStorage()) {
            var pageVisitEndTime = dateNow();
            var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
            if (pageVisitDataJsonStr && hasJSON()) {
              prevPageVisitData = getJSON().parse(pageVisitDataJsonStr);
              prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[_DYN_PAGE_VISIT_START_TIM20];
              utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
            }
          }
        } catch (e) {
          _warnToConsole(logger, "Stop page visit timer failed: " + dumpObj(e));
          prevPageVisitData = null;
        }
        return prevPageVisitData;
      }
      objDefineAccessors(_self, "_logger", function() {
        return logger;
      });
      objDefineAccessors(_self, "pageVisitTimeTrackingHandler", function() {
        return pageVisitTimeTrackingHandler;
      });
    });
  }
  PageVisitTimeManager2.__ieDyn = 1;
  return PageVisitTimeManager2;
}();
var PageVisitData = function() {
  function PageVisitData2(pageName, pageUrl) {
    this[_DYN_PAGE_VISIT_START_TIM20] = dateNow();
    this.pageName = pageName;
    this.pageUrl = pageUrl;
  }
  return PageVisitData2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-analytics-js@2.8.8/node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Timing.js
var Timing = function() {
  function Timing2(logger, name) {
    var _self = this;
    var _events = {};
    _self.start = function(name2) {
      if (typeof _events[name2] !== "undefined") {
        _throwInternal(logger, 2, 62, "start was called more than once for this event without calling stop.", { name: name2, key: name2 }, true);
      }
      _events[name2] = +new Date();
    };
    _self.stop = function(name2, url, properties, measurements) {
      var start = _events[name2];
      if (isNaN(start)) {
        _throwInternal(logger, 2, 63, "stop was called without a corresponding start.", { name: name2, key: name2 }, true);
      } else {
        var end = +new Date();
        var duration = dateTimeUtilsDuration(start, end);
        _self.action(name2, url, duration, properties, measurements);
      }
      delete _events[name2];
      _events[name2] = void 0;
    };
  }
  return Timing2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-analytics-js@2.8.8/node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/AnalyticsPlugin.js
var strEvent = "event";
function _dispatchEvent(target, evnt) {
  if (target && target.dispatchEvent && evnt) {
    target.dispatchEvent(evnt);
  }
}
function _getReason(error) {
  if (error && error.reason) {
    var reason = error.reason;
    if (!isString(reason) && isFunction(reason[_DYN_TO_STRING])) {
      return reason[_DYN_TO_STRING]();
    }
    return dumpObj(reason);
  }
  return error || "";
}
var MinMilliSeconds = 6e4;
function _configMilliseconds(value, defValue) {
  value = value || defValue;
  if (value < MinMilliSeconds) {
    value = MinMilliSeconds;
  }
  return value;
}
function _getDefaultConfig(config) {
  if (!config) {
    config = {};
  }
  config.sessionRenewalMs = _configMilliseconds(config.sessionRenewalMs, 30 * 60 * 1e3);
  config.sessionExpirationMs = _configMilliseconds(config.sessionExpirationMs, 24 * 60 * 60 * 1e3);
  config[_DYN_DISABLE_EXCEPTION_TR0] = stringToBoolOrDefault(config[_DYN_DISABLE_EXCEPTION_TR0]);
  config[_DYN_AUTO_TRACK_PAGE_VISI1] = stringToBoolOrDefault(config[_DYN_AUTO_TRACK_PAGE_VISI1]);
  config[_DYN_OVERRIDE_PAGE_VIEW_D2] = stringToBoolOrDefault(config[_DYN_OVERRIDE_PAGE_VIEW_D2]);
  config[_DYN_ENABLE_UNHANDLED_PRO3] = stringToBoolOrDefault(config[_DYN_ENABLE_UNHANDLED_PRO3]);
  if (isNaN(config[_DYN_SAMPLING_PERCENTAGE]) || config[_DYN_SAMPLING_PERCENTAGE] <= 0 || config[_DYN_SAMPLING_PERCENTAGE] >= 100) {
    config[_DYN_SAMPLING_PERCENTAGE] = 100;
  }
  config[_DYN_IS_STORAGE_USE_DISAB4] = stringToBoolOrDefault(config[_DYN_IS_STORAGE_USE_DISAB4]);
  config[_DYN_IS_BROWSER_LINK_TRAC5] = stringToBoolOrDefault(config[_DYN_IS_BROWSER_LINK_TRAC5]);
  config[_DYN_ENABLE_AUTO_ROUTE_TR6] = stringToBoolOrDefault(config[_DYN_ENABLE_AUTO_ROUTE_TR6]);
  config[_DYN_NAME_PREFIX] = config[_DYN_NAME_PREFIX] || "";
  config.enableDebug = stringToBoolOrDefault(config.enableDebug);
  config[_DYN_DISABLE_FLUSH_ON_BEF7] = stringToBoolOrDefault(config[_DYN_DISABLE_FLUSH_ON_BEF7]);
  config.disableFlushOnUnload = stringToBoolOrDefault(config.disableFlushOnUnload, config[_DYN_DISABLE_FLUSH_ON_BEF7]);
  return config;
}
function _updateStorageUsage(extConfig) {
  if (!isUndefined(extConfig[_DYN_IS_STORAGE_USE_DISAB4])) {
    if (extConfig[_DYN_IS_STORAGE_USE_DISAB4]) {
      utlDisableStorage();
    } else {
      utlEnableStorage();
    }
  }
}
var AnalyticsPlugin = function(_super) {
  __extendsFn(AnalyticsPlugin2, _super);
  function AnalyticsPlugin2() {
    var _this = _super.call(this) || this;
    _this.identifier = AnalyticsPluginIdentifier;
    _this.priority = 180;
    _this.autoRoutePVDelay = 500;
    var _eventTracking;
    var _pageTracking;
    var _pageViewManager;
    var _pageViewPerformanceManager;
    var _pageVisitTimeManager;
    var _preInitTelemetryInitializers;
    var _isBrowserLinkTrackingEnabled;
    var _browserLinkInitializerAdded;
    var _enableAutoRouteTracking;
    var _historyListenerAdded;
    var _disableExceptionTracking;
    var _autoExceptionInstrumented;
    var _enableUnhandledPromiseRejectionTracking;
    var _autoUnhandledPromiseInstrumented;
    var _trackAjaxAttempts = 0;
    var _prevUri;
    var _currUri;
    var _evtNamespace;
    dynamicProto(AnalyticsPlugin2, _this, function(_self, _base) {
      var _addHook = _base._addHook;
      _initDefaults();
      _self.getCookieMgr = function() {
        return safeGetCookieMgr(_self[_DYN_CORE]);
      };
      _self.processTelemetry = function(env, itemCtx) {
        _self.processNext(env, itemCtx);
      };
      _self.trackEvent = function(event, customProperties) {
        try {
          var telemetryItem = createTelemetryItem(event, Event2[_DYN_DATA_TYPE], Event2[_DYN_ENVELOPE_TYPE], _self[_DYN_DIAG_LOG](), customProperties);
          _self[_DYN_CORE][_DYN_TRACK](telemetryItem);
        } catch (e) {
          _throwInternal2(2, 39, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self.startTrackEvent = function(name) {
        try {
          _eventTracking.start(name);
        } catch (e) {
          _throwInternal2(1, 29, "startTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self.stopTrackEvent = function(name, properties, measurements) {
        try {
          _eventTracking.stop(name, void 0, properties, measurements);
        } catch (e) {
          _throwInternal2(1, 30, "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self.trackTrace = function(trace, customProperties) {
        try {
          var telemetryItem = createTelemetryItem(trace, Trace[_DYN_DATA_TYPE], Trace[_DYN_ENVELOPE_TYPE], _self[_DYN_DIAG_LOG](), customProperties);
          _self[_DYN_CORE][_DYN_TRACK](telemetryItem);
        } catch (e) {
          _throwInternal2(2, 39, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self.trackMetric = function(metric, customProperties) {
        try {
          var telemetryItem = createTelemetryItem(metric, Metric[_DYN_DATA_TYPE], Metric[_DYN_ENVELOPE_TYPE], _self[_DYN_DIAG_LOG](), customProperties);
          _self[_DYN_CORE][_DYN_TRACK](telemetryItem);
        } catch (e) {
          _throwInternal2(1, 36, "trackMetric failed, metric will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self[_DYN_TRACK_PAGE_VIEW] = function(pageView, customProperties) {
        try {
          var inPv = pageView || {};
          _pageViewManager[_DYN_TRACK_PAGE_VIEW](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
          if (_self.config[_DYN_AUTO_TRACK_PAGE_VISI1]) {
            _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_9](inPv.name, inPv.uri);
          }
        } catch (e) {
          _throwInternal2(1, 37, "trackPageView failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self[_DYN_SEND_PAGE_VIEW_INTER10] = function(pageView, properties, systemProperties) {
        var doc = getDocument();
        if (doc) {
          pageView.refUri = pageView.refUri === void 0 ? doc.referrer : pageView.refUri;
        }
        var telemetryItem = createTelemetryItem(pageView, PageView[_DYN_DATA_TYPE], PageView[_DYN_ENVELOPE_TYPE], _self[_DYN_DIAG_LOG](), properties, systemProperties);
        _self[_DYN_CORE][_DYN_TRACK](telemetryItem);
        _trackAjaxAttempts = 0;
      };
      _self[_DYN_SEND_PAGE_VIEW_PERFO11] = function(pageViewPerformance, properties, systemProperties) {
        var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformance[_DYN_DATA_TYPE], PageViewPerformance[_DYN_ENVELOPE_TYPE], _self[_DYN_DIAG_LOG](), properties, systemProperties);
        _self[_DYN_CORE][_DYN_TRACK](telemetryItem);
      };
      _self.trackPageViewPerformance = function(pageViewPerformance, customProperties) {
        var inPvp = pageViewPerformance || {};
        try {
          _pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P12](inPvp);
          _self[_DYN_SEND_PAGE_VIEW_PERFO11](inPvp, customProperties);
        } catch (e) {
          _throwInternal2(1, 37, "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self.startTrackPage = function(name) {
        try {
          if (typeof name !== "string") {
            var doc = getDocument();
            name = doc && doc.title || "";
          }
          _pageTracking.start(name);
        } catch (e) {
          _throwInternal2(1, 31, "startTrackPage failed, page view may not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self.stopTrackPage = function(name, url, properties, measurement) {
        try {
          if (typeof name !== "string") {
            var doc = getDocument();
            name = doc && doc.title || "";
          }
          if (typeof url !== "string") {
            var loc = getLocation();
            url = loc && loc[_DYN_HREF] || "";
          }
          _pageTracking.stop(name, url, properties, measurement);
          if (_self.config[_DYN_AUTO_TRACK_PAGE_VISI1]) {
            _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_9](name, url);
          }
        } catch (e) {
          _throwInternal2(1, 32, "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self[_DYN_SEND_EXCEPTION_INTER13] = function(exception, customProperties, systemProperties) {
        var theError = exception[_DYN_EXCEPTION] || exception[_DYN_ERROR] || new Error(strNotSpecified);
        var exceptionPartB = new Exception(_self[_DYN_DIAG_LOG](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
        var telemetryItem = createTelemetryItem(exceptionPartB, Exception[_DYN_DATA_TYPE], Exception[_DYN_ENVELOPE_TYPE], _self[_DYN_DIAG_LOG](), customProperties, systemProperties);
        _self[_DYN_CORE][_DYN_TRACK](telemetryItem);
      };
      _self.trackException = function(exception, customProperties) {
        if (exception && !exception[_DYN_EXCEPTION] && exception[_DYN_ERROR]) {
          exception[_DYN_EXCEPTION] = exception[_DYN_ERROR];
        }
        try {
          _self[_DYN_SEND_EXCEPTION_INTER13](exception, customProperties);
        } catch (e) {
          _throwInternal2(1, 35, "trackException failed, exception will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
      };
      _self[_DYN__ONERROR] = function(exception) {
        var error = exception && exception[_DYN_ERROR];
        var evt = exception && exception.evt;
        try {
          if (!evt) {
            var _window = getWindow();
            if (_window) {
              evt = _window[strEvent];
            }
          }
          var url = exception && exception.url || (getDocument() || {}).URL;
          var errorSrc = exception[_DYN_ERROR_SRC] || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER] || 0);
          var properties = {
            errorSrc,
            url,
            lineNumber: exception[_DYN_LINE_NUMBER] || 0,
            columnNumber: exception[_DYN_COLUMN_NUMBER] || 0,
            message: exception[_DYN_MESSAGE]
          };
          if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR])) {
            _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI14]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER] || 0, exception[_DYN_COLUMN_NUMBER] || 0, error, evt, null, errorSrc), properties);
          } else {
            if (!exception[_DYN_ERROR_SRC]) {
              exception[_DYN_ERROR_SRC] = errorSrc;
            }
            _self.trackException({ exception, severityLevel: 3 }, properties);
          }
        } catch (e) {
          var errorString = error ? error.name + ", " + error[_DYN_MESSAGE] : "null";
          _throwInternal2(1, 11, "_onError threw exception while logging error, error will not be collected: " + getExceptionName(e), { exception: dumpObj(e), errorString });
        }
      };
      _self[_DYN_ADD_TELEMETRY_INITIA15] = function(telemetryInitializer) {
        if (_self[_DYN_CORE]) {
          return _self[_DYN_CORE][_DYN_ADD_TELEMETRY_INITIA15](telemetryInitializer);
        }
        if (!_preInitTelemetryInitializers) {
          _preInitTelemetryInitializers = [];
        }
        _preInitTelemetryInitializers.push(telemetryInitializer);
      };
      _self.initialize = function(config, core, extensions, pluginChain) {
        if (_self.isInitialized()) {
          return;
        }
        if (isNullOrUndefined(core)) {
          throwError("Error initializing");
        }
        _base.initialize(config, core, extensions, pluginChain);
        try {
          _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
          if (_preInitTelemetryInitializers) {
            arrForEach(_preInitTelemetryInitializers, function(initializer) {
              core[_DYN_ADD_TELEMETRY_INITIA15](initializer);
            });
            _preInitTelemetryInitializers = null;
          }
          var extConfig = _populateDefaults(config);
          _updateStorageUsage(extConfig);
          _pageViewPerformanceManager = new PageViewPerformanceManager(_self[_DYN_CORE]);
          _pageViewManager = new PageViewManager(_this, extConfig[_DYN_OVERRIDE_PAGE_VIEW_D2], _self[_DYN_CORE], _pageViewPerformanceManager);
          _pageVisitTimeManager = new PageVisitTimeManager(_self[_DYN_DIAG_LOG](), function(pageName, pageUrl, pageVisitTime) {
            return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
          });
          _updateBrowserLinkTracking(extConfig, config);
          _eventTracking = new Timing(_self[_DYN_DIAG_LOG](), "trackEvent");
          _eventTracking.action = function(name, url, duration, properties, measurements) {
            if (!properties) {
              properties = {};
            }
            if (!measurements) {
              measurements = {};
            }
            properties.duration = duration[_DYN_TO_STRING]();
            _self.trackEvent({ name, properties, measurements });
          };
          _pageTracking = new Timing(_self[_DYN_DIAG_LOG](), "trackPageView");
          _pageTracking.action = function(name, url, duration, properties, measurements) {
            if (isNullOrUndefined(properties)) {
              properties = {};
            }
            properties.duration = duration[_DYN_TO_STRING]();
            var pageViewItem = {
              name,
              uri: url,
              properties,
              measurements
            };
            _self[_DYN_SEND_PAGE_VIEW_INTER10](pageViewItem, properties);
          };
          if (hasWindow()) {
            _updateExceptionTracking(extConfig);
            _updateLocationChange(extConfig);
          }
        } catch (e) {
          _self.setInitialized(false);
          throw e;
        }
      };
      _self._doTeardown = function(unloadCtx, unloadState) {
        _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
        eventOff(window, null, null, _evtNamespace);
        _initDefaults();
      };
      function _populateDefaults(config) {
        var ctx = createProcessTelemetryContext(null, config, _self[_DYN_CORE]);
        var identifier = _self.identifier;
        var defaults = _getDefaultConfig(config);
        var extConfig = _self.config = ctx.getExtCfg(identifier);
        if (defaults !== void 0) {
          objForEachKey(defaults, function(field, value) {
            extConfig[field] = ctx.getConfig(identifier, field, value);
            if (extConfig[field] === void 0) {
              extConfig = value;
            }
          });
        }
        return extConfig;
      }
      function _updateBrowserLinkTracking(extConfig, config) {
        _isBrowserLinkTrackingEnabled = extConfig[_DYN_IS_BROWSER_LINK_TRAC5] || config[_DYN_IS_BROWSER_LINK_TRAC5];
        _addDefaultTelemetryInitializers();
      }
      function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
        var properties = { PageName: pageName, PageUrl: pageUrl };
        _self.trackMetric({
          name: "PageVisitTime",
          average: pageVisitTime,
          max: pageVisitTime,
          min: pageVisitTime,
          sampleCount: 1
        }, properties);
      }
      function _addDefaultTelemetryInitializers() {
        if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
          var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
          var dropBrowserLinkRequests = function(envelope) {
            if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyData[_DYN_DATA_TYPE]) {
              var remoteData = envelope.baseData;
              if (remoteData) {
                for (var i = 0; i < browserLinkPaths_1[_DYN_LENGTH]; i++) {
                  if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) {
                    return false;
                  }
                }
              }
            }
            return true;
          };
          _self[_DYN_ADD_TELEMETRY_INITIA15](dropBrowserLinkRequests);
          _browserLinkInitializerAdded = true;
        }
      }
      function _sendCORSException(exception, properties) {
        var telemetryItem = createTelemetryItem(exception, Exception[_DYN_DATA_TYPE], Exception[_DYN_ENVELOPE_TYPE], _self[_DYN_DIAG_LOG](), properties);
        _self[_DYN_CORE][_DYN_TRACK](telemetryItem);
      }
      function _updateExceptionTracking(extConfig) {
        var _window = getWindow();
        var locn = getLocation(true);
        _disableExceptionTracking = extConfig[_DYN_DISABLE_EXCEPTION_TR0];
        if (!_disableExceptionTracking && !_autoExceptionInstrumented && !extConfig.autoExceptionInstrumented) {
          _addHook(InstrumentEvent(_window, "onerror", {
            ns: _evtNamespace,
            rsp: function(callDetails, message, url, lineNumber, columnNumber, error) {
              if (!_disableExceptionTracking && callDetails.rslt !== true) {
                _self[_DYN__ONERROR](Exception[_DYN__CREATE_AUTO_EXCEPTI14](message, url, lineNumber, columnNumber, error, callDetails.evt));
              }
            }
          }, false));
          _autoExceptionInstrumented = true;
        }
        _addUnhandledPromiseRejectionTracking(extConfig, _window, locn);
      }
      function _updateLocationChange(extConfig) {
        var win = getWindow();
        var locn = getLocation(true);
        _enableAutoRouteTracking = extConfig[_DYN_ENABLE_AUTO_ROUTE_TR6] === true;
        if (win && _enableAutoRouteTracking && hasHistory()) {
          var _history = getHistory();
          if (isFunction(_history.pushState) && isFunction(_history.replaceState) && typeof Event !== strShimUndefined) {
            _addHistoryListener(extConfig, win, _history, locn);
          }
        }
      }
      function _getDistributedTraceCtx() {
        var distributedTraceCtx = null;
        if (_self[_DYN_CORE] && _self[_DYN_CORE].getTraceCtx) {
          distributedTraceCtx = _self[_DYN_CORE].getTraceCtx(false);
        }
        if (!distributedTraceCtx) {
          var properties = _self[_DYN_CORE].getPlugin(PropertiesPluginIdentifier);
          if (properties) {
            var context = properties.plugin.context;
            if (context) {
              distributedTraceCtx = createDistributedTraceContextFromTrace(context.telemetryTrace);
            }
          }
        }
        return distributedTraceCtx;
      }
      function _addHistoryListener(extConfig, win, history, locn) {
        var namePrefix = extConfig[_DYN_NAME_PREFIX] || "";
        function _popstateHandler() {
          if (_enableAutoRouteTracking) {
            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
          }
        }
        function _locationChangeHandler() {
          if (_currUri) {
            _prevUri = _currUri;
            _currUri = locn && locn[_DYN_HREF] || "";
          } else {
            _currUri = locn && locn[_DYN_HREF] || "";
          }
          if (_enableAutoRouteTracking) {
            var distributedTraceCtx = _getDistributedTraceCtx();
            if (distributedTraceCtx) {
              distributedTraceCtx.setTraceId(generateW3CId());
              var traceLocationName = "_unknown_";
              if (locn && locn.pathname) {
                traceLocationName = locn.pathname + (locn.hash || "");
              }
              distributedTraceCtx.setName(dataSanitizeString(_self[_DYN_DIAG_LOG](), traceLocationName));
            }
            setTimeout(function(uri) {
              _self[_DYN_TRACK_PAGE_VIEW]({ refUri: uri, properties: { duration: 0 } });
            }.bind(this, _prevUri), _self.autoRoutePVDelay);
          }
        }
        if (!_historyListenerAdded) {
          _addHook(InstrumentEvent(history, "pushState", {
            ns: _evtNamespace,
            rsp: function() {
              if (_enableAutoRouteTracking) {
                _dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
                _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
              }
            }
          }, true));
          _addHook(InstrumentEvent(history, "replaceState", {
            ns: _evtNamespace,
            rsp: function() {
              if (_enableAutoRouteTracking) {
                _dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
                _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
              }
            }
          }, true));
          eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
          eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
          _historyListenerAdded = true;
        }
      }
      function _addUnhandledPromiseRejectionTracking(extConfig, _window, _location) {
        _enableUnhandledPromiseRejectionTracking = extConfig[_DYN_ENABLE_UNHANDLED_PRO3] === true;
        if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
          _addHook(InstrumentEvent(_window, "onunhandledrejection", {
            ns: _evtNamespace,
            rsp: function(callDetails, error) {
              if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) {
                _self[_DYN__ONERROR](Exception[_DYN__CREATE_AUTO_EXCEPTI14](_getReason(error), _location ? _location[_DYN_HREF] : "", 0, 0, error, callDetails.evt));
              }
            }
          }, false));
          _autoUnhandledPromiseInstrumented = true;
          extConfig.autoUnhandledPromiseInstrumented = _autoUnhandledPromiseInstrumented;
        }
      }
      function _throwInternal2(severity, msgId, msg, properties, isUserAct) {
        _self[_DYN_DIAG_LOG]().throwInternal(severity, msgId, msg, properties, isUserAct);
      }
      function _initDefaults() {
        _eventTracking = null;
        _pageTracking = null;
        _pageViewManager = null;
        _pageViewPerformanceManager = null;
        _pageVisitTimeManager = null;
        _preInitTelemetryInitializers = null;
        _isBrowserLinkTrackingEnabled = false;
        _browserLinkInitializerAdded = false;
        _enableAutoRouteTracking = false;
        _historyListenerAdded = false;
        _disableExceptionTracking = false;
        _autoExceptionInstrumented = false;
        _enableUnhandledPromiseRejectionTracking = false;
        _autoUnhandledPromiseInstrumented = false;
        _trackAjaxAttempts = 0;
        var location = getLocation(true);
        _prevUri = location && location[_DYN_HREF] || "";
        _currUri = null;
        _evtNamespace = null;
      }
      objDefineAccessors(_self, "_pageViewManager", function() {
        return _pageViewManager;
      });
      objDefineAccessors(_self, "_pageViewPerformanceManager", function() {
        return _pageViewPerformanceManager;
      });
      objDefineAccessors(_self, "_pageVisitTimeManager", function() {
        return _pageVisitTimeManager;
      });
      objDefineAccessors(_self, "_evtNamespace", function() {
        return "." + _evtNamespace;
      });
    });
    return _this;
  }
  AnalyticsPlugin2.Version = "2.8.8";
  AnalyticsPlugin2.getDefaultConfig = _getDefaultConfig;
  return AnalyticsPlugin2;
}(BaseTelemetryPlugin);

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/InternalConstants.js
var STR_DURATION = "duration";

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/__DynamicConstants.js
var _DYN_TAGS = "tags";
var _DYN_DEVICE_TYPE = "deviceType";
var _DYN_DATA = "data";
var _DYN_NAME = "name";
var _DYN_TRACE_ID = "traceID";
var _DYN_LENGTH2 = "length";
var _DYN_STRINGIFY = "stringify";
var _DYN_MEASUREMENTS = "measurements";
var _DYN_DATA_TYPE2 = "dataType";
var _DYN_ENVELOPE_TYPE2 = "envelopeType";
var _DYN_TO_STRING2 = "toString";
var _DYN_ON_LINE = "onLine";
var _DYN_ENQUEUE = "enqueue";
var _DYN_COUNT = "count";
var _DYN_PUSH = "push";
var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson";
var _DYN_CLEAR = "clear";
var _DYN_BATCH_PAYLOADS = "batchPayloads";
var _DYN_MARK_AS_SENT = "markAsSent";
var _DYN_CLEAR_SENT = "clearSent";
var _DYN__BUFFER__KEY = "BUFFER_KEY";
var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY";
var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE";
var _DYN_NAME_PREFIX2 = "namePrefix";
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes";
var _DYN_TRIGGER_SEND = "triggerSend";
var _DYN_DIAG_LOG2 = "diagLog";
var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon";
var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled";
var _DYN__SENDER = "_sender";
var _DYN__SENDER_CONFIG = "_senderConfig";
var _DYN__BUFFER = "_buffer";
var _DYN_ENABLE_SESSION_STORA4 = "enableSessionStorageBuffer";
var _DYN_SAMPLING_PERCENTAGE2 = "samplingPercentage";
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey";
var _DYN_ENDPOINT_URL = "endpointUrl";
var _DYN_CUSTOM_HEADERS = "customHeaders";
var _DYN_DISABLE_XHR = "disableXhr";
var _DYN_ONUNLOAD_DISABLE_FET5 = "onunloadDisableFetch";
var _DYN_DISABLE_TELEMETRY = "disableTelemetry";
var _DYN_BASE_TYPE = "baseType";
var _DYN_SAMPLE_RATE = "sampleRate";
var _DYN_CONVERT_UNDEFINED = "convertUndefined";
var _DYN__XHR_READY_STATE_CHA6 = "_xhrReadyStateChange";
var _DYN__ON_ERROR = "_onError";
var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess";
var _DYN__ON_SUCCESS = "_onSuccess";
var _DYN_ITEMS_ACCEPTED = "itemsAccepted";
var _DYN_ITEMS_RECEIVED = "itemsReceived";
var _DYN_IS_RETRY_DISABLED = "isRetryDisabled";
var _DYN_SET_REQUEST_HEADER = "setRequestHeader";
var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval";
var _DYN_EVENTS_SEND_REQUEST = "eventsSendRequest";
var _DYN_DISABLE_INSTRUMENTAT7 = "disableInstrumentationKeyValidation";
var _DYN_GET_SAMPLING_SCORE = "getSamplingScore";
var _DYN_GET_HASH_CODE_SCORE = "getHashCodeScore";

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/EnvelopeCreator.js
var strBaseType = "baseType";
var strBaseData = "baseData";
var strProperties = "properties";
var strTrue = "true";
function _setValueIf(target, field, value) {
  return setValue(target, field, value, isTruthy);
}
function _extractPartAExtensions(logger, item, env) {
  var envTags = env[_DYN_TAGS] = env[_DYN_TAGS] || {};
  var itmExt = item.ext = item.ext || {};
  var itmTags = item[_DYN_TAGS] = item[_DYN_TAGS] || [];
  var extUser = itmExt.user;
  if (extUser) {
    _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
    _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
  }
  var extApp = itmExt.app;
  if (extApp) {
    _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
  }
  var extDevice = itmExt.device;
  if (extDevice) {
    _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
    _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE], extDevice.deviceClass);
    _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
    _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
    _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE], extDevice[_DYN_DEVICE_TYPE]);
  }
  var web = item.ext.web;
  if (web) {
    _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
    _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
    _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
    var envData = env[_DYN_DATA] = env[_DYN_DATA] || {};
    var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
    var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
    _setValueIf(envProps, "domain", web.domain);
    _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
    _setValueIf(envProps, "screenRes", web.screenRes);
    _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
  }
  var extOs = itmExt.os;
  if (extOs) {
    _setValueIf(envTags, CtxTagKeys.deviceOS, extOs[_DYN_NAME]);
  }
  var extTrace = itmExt.trace;
  if (extTrace) {
    _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
    _setValueIf(envTags, CtxTagKeys.operationName, dataSanitizeString(logger, extTrace[_DYN_NAME]));
    _setValueIf(envTags, CtxTagKeys.operationId, extTrace[_DYN_TRACE_ID]);
  }
  var tgs = {};
  for (var i = itmTags[_DYN_LENGTH2] - 1; i >= 0; i--) {
    var tg = itmTags[i];
    objForEachKey(tg, function(key, value) {
      tgs[key] = value;
    });
    itmTags.splice(i, 1);
  }
  objForEachKey(itmTags, function(tg2, value) {
    tgs[tg2] = value;
  });
  var theTags = __assignFn(__assignFn({}, envTags), tgs);
  if (!theTags[CtxTagKeys.internalSdkVersion]) {
    theTags[CtxTagKeys.internalSdkVersion] = "javascript:".concat(EnvelopeCreator.Version);
  }
  env[_DYN_TAGS] = optimizeObject(theTags);
}
function _extractPropsAndMeasurements(data, properties, measurements) {
  if (!isNullOrUndefined(data)) {
    objForEachKey(data, function(key, value) {
      if (isNumber(value)) {
        measurements[key] = value;
      } else if (isString(value)) {
        properties[key] = value;
      } else if (hasJSON()) {
        properties[key] = getJSON()[_DYN_STRINGIFY](value);
      }
    });
  }
}
function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
  if (!isNullOrUndefined(properties)) {
    objForEachKey(properties, function(key, value) {
      properties[key] = value || customUndefinedValue;
    });
  }
}
function _createEnvelope(logger, envelopeType, telemetryItem, data) {
  var envelope = new Envelope(logger, data, envelopeType);
  _setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
  if ((telemetryItem[strBaseData] || {}).startTime) {
    envelope.time = toISOString(telemetryItem[strBaseData].startTime);
  }
  envelope.iKey = telemetryItem.iKey;
  var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
  envelope[_DYN_NAME] = envelope[_DYN_NAME].replace("{0}", iKeyNoDashes);
  _extractPartAExtensions(logger, telemetryItem, envelope);
  telemetryItem[_DYN_TAGS] = telemetryItem[_DYN_TAGS] || [];
  return optimizeObject(envelope);
}
function EnvelopeCreatorInit(logger, telemetryItem) {
  if (isNullOrUndefined(telemetryItem[strBaseData])) {
    _throwInternal(logger, 1, 46, "telemetryItem.baseData cannot be null.");
  }
}
var EnvelopeCreator = {
  Version: "2.8.8"
};
function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
  var customProperties = telemetryItem[strBaseData][strProperties] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA], customProperties, customMeasurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
  }
  var bd = telemetryItem[strBaseData];
  if (isNullOrUndefined(bd)) {
    _warnToConsole(logger, "Invalid input for dependency data");
    return null;
  }
  var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
  var remoteDepData = new RemoteDependencyData(logger, bd.id, bd.target, bd[_DYN_NAME], bd[STR_DURATION], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
  var data = new Data(RemoteDependencyData[_DYN_DATA_TYPE2], remoteDepData);
  return _createEnvelope(logger, RemoteDependencyData[_DYN_ENVELOPE_TYPE2], telemetryItem, data);
}
function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var customProperties = {};
  var customMeasurements = {};
  if (telemetryItem[strBaseType] !== Event2[_DYN_DATA_TYPE2]) {
    customProperties["baseTypeSource"] = telemetryItem[strBaseType];
  }
  if (telemetryItem[strBaseType] === Event2[_DYN_DATA_TYPE2]) {
    customProperties = telemetryItem[strBaseData][strProperties] || {};
    customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
  } else {
    if (telemetryItem[strBaseData]) {
      _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
    }
  }
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA], customProperties, customMeasurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
  }
  var eventName = telemetryItem[strBaseData][_DYN_NAME];
  var eventData = new Event2(logger, eventName, customProperties, customMeasurements);
  var data = new Data(Event2[_DYN_DATA_TYPE2], eventData);
  return _createEnvelope(logger, Event2[_DYN_ENVELOPE_TYPE2], telemetryItem, data);
}
function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
  var customProperties = telemetryItem[strBaseData][strProperties] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA], customProperties, customMeasurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
  }
  var bd = telemetryItem[strBaseData];
  var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
  var data = new Data(Exception[_DYN_DATA_TYPE2], exData);
  return _createEnvelope(logger, Exception[_DYN_ENVELOPE_TYPE2], telemetryItem, data);
}
function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var baseData = telemetryItem[strBaseData];
  var props = baseData[strProperties] || {};
  var measurements = baseData[_DYN_MEASUREMENTS] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA], props, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
  }
  var baseMetricData = new Metric(logger, baseData[_DYN_NAME], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
  var data = new Data(Metric[_DYN_DATA_TYPE2], baseMetricData);
  return _createEnvelope(logger, Metric[_DYN_ENVELOPE_TYPE2], telemetryItem, data);
}
function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var duration;
  var baseData = telemetryItem[strBaseData];
  if (!isNullOrUndefined(baseData) && !isNullOrUndefined(baseData[strProperties]) && !isNullOrUndefined(baseData[strProperties][STR_DURATION])) {
    duration = baseData[strProperties][STR_DURATION];
    delete baseData[strProperties][STR_DURATION];
  } else if (!isNullOrUndefined(telemetryItem[_DYN_DATA]) && !isNullOrUndefined(telemetryItem[_DYN_DATA][STR_DURATION])) {
    duration = telemetryItem[_DYN_DATA][STR_DURATION];
    delete telemetryItem[_DYN_DATA][STR_DURATION];
  }
  var bd = telemetryItem[strBaseData];
  var currentContextId;
  if (((telemetryItem.ext || {}).trace || {})[_DYN_TRACE_ID]) {
    currentContextId = telemetryItem.ext.trace[_DYN_TRACE_ID];
  }
  var id = bd.id || currentContextId;
  var name = bd[_DYN_NAME];
  var url = bd.uri;
  var properties = bd[strProperties] || {};
  var measurements = bd[_DYN_MEASUREMENTS] || {};
  if (!isNullOrUndefined(bd.refUri)) {
    properties["refUri"] = bd.refUri;
  }
  if (!isNullOrUndefined(bd.pageType)) {
    properties["pageType"] = bd.pageType;
  }
  if (!isNullOrUndefined(bd.isLoggedIn)) {
    properties["isLoggedIn"] = bd.isLoggedIn[_DYN_TO_STRING2]();
  }
  if (!isNullOrUndefined(bd[strProperties])) {
    var pageTags = bd[strProperties];
    objForEachKey(pageTags, function(key, value) {
      properties[key] = value;
    });
  }
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA], properties, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
  }
  var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
  var data = new Data(PageView[_DYN_DATA_TYPE2], pageViewData);
  return _createEnvelope(logger, PageView[_DYN_ENVELOPE_TYPE2], telemetryItem, data);
}
function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var bd = telemetryItem[strBaseData];
  var name = bd[_DYN_NAME];
  var url = bd.uri || bd.url;
  var properties = bd[strProperties] || {};
  var measurements = bd[_DYN_MEASUREMENTS] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA], properties, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
  }
  var baseData = new PageViewPerformance(logger, name, url, void 0, properties, measurements, bd);
  var data = new Data(PageViewPerformance[_DYN_DATA_TYPE2], baseData);
  return _createEnvelope(logger, PageViewPerformance[_DYN_ENVELOPE_TYPE2], telemetryItem, data);
}
function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var message = telemetryItem[strBaseData].message;
  var severityLevel = telemetryItem[strBaseData].severityLevel;
  var props = telemetryItem[strBaseData][strProperties] || {};
  var measurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA], props, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
  }
  var baseData = new Trace(logger, message, severityLevel, props, measurements);
  var data = new Data(Trace[_DYN_DATA_TYPE2], baseData);
  return _createEnvelope(logger, Trace[_DYN_ENVELOPE_TYPE2], telemetryItem, data);
}

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/Offline.js
function _disableEvents(target, evtNamespace) {
  eventOff(target, null, null, evtNamespace);
}
function createOfflineListener(parentEvtNamespace) {
  var _document = getDocument();
  var _navigator = getNavigator();
  var _isListening = false;
  var _onlineStatus = true;
  var _evtNamespace = mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
  try {
    if (_enableEvents(getWindow())) {
      _isListening = true;
    }
    if (_document) {
      var target = _document.body || _document;
      if (target.ononline) {
        if (_enableEvents(target)) {
          _isListening = true;
        }
      }
    }
    if (_isListening) {
      if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE])) {
        _onlineStatus = _navigator[_DYN_ON_LINE];
      }
    }
  } catch (e) {
    _isListening = false;
  }
  function _enableEvents(target2) {
    var enabled = false;
    if (target2) {
      enabled = eventOn(target2, "online", _setOnline, _evtNamespace);
      if (enabled) {
        eventOn(target2, "offline", _setOffline, _evtNamespace);
      }
    }
    return enabled;
  }
  function _setOnline() {
    _onlineStatus = true;
  }
  function _setOffline() {
    _onlineStatus = false;
  }
  function _isOnline() {
    var result = true;
    if (_isListening) {
      result = _onlineStatus;
    } else if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE])) {
      result = _navigator[_DYN_ON_LINE];
    }
    return result;
  }
  function _unload() {
    var win = getWindow();
    if (win && _isListening) {
      _disableEvents(win, _evtNamespace);
      if (_document) {
        var target2 = _document.body || _document;
        if (!isUndefined(target2.ononline)) {
          _disableEvents(target2, _evtNamespace);
        }
      }
      _isListening = false;
    }
  }
  return {
    isOnline: _isOnline,
    isListening: function() {
      return _isListening;
    },
    unload: _unload
  };
}

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/SendBuffer.js
var BaseSendBuffer = function() {
  function BaseSendBuffer2(logger, config) {
    var _buffer = [];
    var _bufferFullMessageSent = false;
    this._get = function() {
      return _buffer;
    };
    this._set = function(buffer) {
      _buffer = buffer;
      return _buffer;
    };
    dynamicProto(BaseSendBuffer2, this, function(_self) {
      _self[_DYN_ENQUEUE] = function(payload) {
        if (_self[_DYN_COUNT]() >= config.eventsLimitInMem()) {
          if (!_bufferFullMessageSent) {
            _throwInternal(logger, 2, 105, "Maximum in-memory buffer size reached: " + _self[_DYN_COUNT](), true);
            _bufferFullMessageSent = true;
          }
          return;
        }
        _buffer[_DYN_PUSH](payload);
      };
      _self[_DYN_COUNT] = function() {
        return _buffer[_DYN_LENGTH2];
      };
      _self.size = function() {
        var size = _buffer[_DYN_LENGTH2];
        for (var lp = 0; lp < _buffer[_DYN_LENGTH2]; lp++) {
          size += _buffer[lp][_DYN_LENGTH2];
        }
        if (!config[_DYN_EMIT_LINE_DELIMITED_0]()) {
          size += 2;
        }
        return size;
      };
      _self[_DYN_CLEAR] = function() {
        _buffer = [];
        _bufferFullMessageSent = false;
      };
      _self.getItems = function() {
        return _buffer.slice(0);
      };
      _self[_DYN_BATCH_PAYLOADS] = function(payload) {
        if (payload && payload[_DYN_LENGTH2] > 0) {
          var batch = config[_DYN_EMIT_LINE_DELIMITED_0]() ? payload.join("\n") : "[" + payload.join(",") + "]";
          return batch;
        }
        return null;
      };
    });
  }
  BaseSendBuffer2.__ieDyn = 1;
  return BaseSendBuffer2;
}();
var ArraySendBuffer = function(_super) {
  __extendsFn(ArraySendBuffer2, _super);
  function ArraySendBuffer2(logger, config) {
    var _this = _super.call(this, logger, config) || this;
    dynamicProto(ArraySendBuffer2, _this, function(_self, _base) {
      _self[_DYN_MARK_AS_SENT] = function(payload) {
        _base[_DYN_CLEAR]();
      };
      _self[_DYN_CLEAR_SENT] = function(payload) {
      };
    });
    return _this;
  }
  ArraySendBuffer2.__ieDyn = 1;
  return ArraySendBuffer2;
}(BaseSendBuffer);
var SessionStorageSendBuffer = function(_super) {
  __extendsFn(SessionStorageSendBuffer2, _super);
  function SessionStorageSendBuffer2(logger, config) {
    var _this = _super.call(this, logger, config) || this;
    var _bufferFullMessageSent = false;
    dynamicProto(SessionStorageSendBuffer2, _this, function(_self, _base) {
      var bufferItems = _getBuffer(SessionStorageSendBuffer2[_DYN__BUFFER__KEY]);
      var notDeliveredItems = _getBuffer(SessionStorageSendBuffer2[_DYN__SENT__BUFFER__KEY]);
      var buffer = _self._set(bufferItems.concat(notDeliveredItems));
      if (buffer[_DYN_LENGTH2] > SessionStorageSendBuffer2[_DYN__MAX__BUFFER__SIZE]) {
        buffer[_DYN_LENGTH2] = SessionStorageSendBuffer2[_DYN__MAX__BUFFER__SIZE];
      }
      _setBuffer(SessionStorageSendBuffer2[_DYN__SENT__BUFFER__KEY], []);
      _setBuffer(SessionStorageSendBuffer2[_DYN__BUFFER__KEY], buffer);
      _self[_DYN_ENQUEUE] = function(payload) {
        if (_self[_DYN_COUNT]() >= SessionStorageSendBuffer2[_DYN__MAX__BUFFER__SIZE]) {
          if (!_bufferFullMessageSent) {
            _throwInternal(logger, 2, 67, "Maximum buffer size reached: " + _self[_DYN_COUNT](), true);
            _bufferFullMessageSent = true;
          }
          return;
        }
        _base[_DYN_ENQUEUE](payload);
        _setBuffer(SessionStorageSendBuffer2[_DYN__BUFFER__KEY], _self._get());
      };
      _self[_DYN_CLEAR] = function() {
        _base[_DYN_CLEAR]();
        _setBuffer(SessionStorageSendBuffer2[_DYN__BUFFER__KEY], _self._get());
        _setBuffer(SessionStorageSendBuffer2[_DYN__SENT__BUFFER__KEY], []);
        _bufferFullMessageSent = false;
      };
      _self[_DYN_MARK_AS_SENT] = function(payload) {
        _setBuffer(SessionStorageSendBuffer2[_DYN__BUFFER__KEY], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
        var sentElements = _getBuffer(SessionStorageSendBuffer2[_DYN__SENT__BUFFER__KEY]);
        if (sentElements instanceof Array && payload instanceof Array) {
          sentElements = sentElements.concat(payload);
          if (sentElements[_DYN_LENGTH2] > SessionStorageSendBuffer2[_DYN__MAX__BUFFER__SIZE]) {
            _throwInternal(logger, 1, 67, "Sent buffer reached its maximum size: " + sentElements[_DYN_LENGTH2], true);
            sentElements[_DYN_LENGTH2] = SessionStorageSendBuffer2[_DYN__MAX__BUFFER__SIZE];
          }
          _setBuffer(SessionStorageSendBuffer2[_DYN__SENT__BUFFER__KEY], sentElements);
        }
      };
      _self[_DYN_CLEAR_SENT] = function(payload) {
        var sentElements = _getBuffer(SessionStorageSendBuffer2[_DYN__SENT__BUFFER__KEY]);
        sentElements = _removePayloadsFromBuffer(payload, sentElements);
        _setBuffer(SessionStorageSendBuffer2[_DYN__SENT__BUFFER__KEY], sentElements);
      };
      function _removePayloadsFromBuffer(payloads, buffer2) {
        var remaining = [];
        arrForEach(buffer2, function(value) {
          if (!isFunction(value) && arrIndexOf(payloads, value) === -1) {
            remaining[_DYN_PUSH](value);
          }
        });
        return remaining;
      }
      function _getBuffer(key) {
        var prefixedKey = key;
        try {
          prefixedKey = config[_DYN_NAME_PREFIX2] && config[_DYN_NAME_PREFIX2]() ? config[_DYN_NAME_PREFIX2]() + "_" + prefixedKey : prefixedKey;
          var bufferJson = utlGetSessionStorage(logger, prefixedKey);
          if (bufferJson) {
            var buffer_1 = getJSON().parse(bufferJson);
            if (isString(buffer_1)) {
              buffer_1 = getJSON().parse(buffer_1);
            }
            if (buffer_1 && isArray(buffer_1)) {
              return buffer_1;
            }
          }
        } catch (e) {
          _throwInternal(logger, 1, 42, " storage key: " + prefixedKey + ", " + getExceptionName(e), { exception: dumpObj(e) });
        }
        return [];
      }
      function _setBuffer(key, buffer2) {
        var prefixedKey = key;
        try {
          prefixedKey = config[_DYN_NAME_PREFIX2] && config[_DYN_NAME_PREFIX2]() ? config[_DYN_NAME_PREFIX2]() + "_" + prefixedKey : prefixedKey;
          var bufferJson = JSON[_DYN_STRINGIFY](buffer2);
          utlSetSessionStorage(logger, prefixedKey, bufferJson);
        } catch (e) {
          utlSetSessionStorage(logger, prefixedKey, JSON[_DYN_STRINGIFY]([]));
          _throwInternal(logger, 2, 41, " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", { exception: dumpObj(e) });
        }
      }
    });
    return _this;
  }
  SessionStorageSendBuffer2.BUFFER_KEY = "AI_buffer";
  SessionStorageSendBuffer2.SENT_BUFFER_KEY = "AI_sentBuffer";
  SessionStorageSendBuffer2.MAX_BUFFER_SIZE = 2e3;
  return SessionStorageSendBuffer2;
}(BaseSendBuffer);

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/Serializer.js
var Serializer = function() {
  function Serializer2(logger) {
    dynamicProto(Serializer2, this, function(_self) {
      _self.serialize = function(input) {
        var output = _serializeObject(input, "root");
        try {
          return getJSON()[_DYN_STRINGIFY](output);
        } catch (e) {
          _throwInternal(logger, 1, 48, e && isFunction(e[_DYN_TO_STRING2]) ? e[_DYN_TO_STRING2]() : "Error serializing object", null, true);
        }
      };
      function _serializeObject(source, name) {
        var circularReferenceCheck = "__aiCircularRefCheck";
        var output = {};
        if (!source) {
          _throwInternal(logger, 1, 48, "cannot serialize object because it is null or undefined", { name }, true);
          return output;
        }
        if (source[circularReferenceCheck]) {
          _throwInternal(logger, 2, 50, "Circular reference detected while serializing object", { name }, true);
          return output;
        }
        if (!source.aiDataContract) {
          if (name === "measurements") {
            output = _serializeStringMap(source, "number", name);
          } else if (name === "properties") {
            output = _serializeStringMap(source, "string", name);
          } else if (name === "tags") {
            output = _serializeStringMap(source, "string", name);
          } else if (isArray(source)) {
            output = _serializeArray(source, name);
          } else {
            _throwInternal(logger, 2, 49, "Attempting to serialize an object which does not implement ISerializable", { name }, true);
            try {
              getJSON()[_DYN_STRINGIFY](source);
              output = source;
            } catch (e) {
              _throwInternal(logger, 1, 48, e && isFunction(e[_DYN_TO_STRING2]) ? e[_DYN_TO_STRING2]() : "Error serializing object", null, true);
            }
          }
          return output;
        }
        source[circularReferenceCheck] = true;
        objForEachKey(source.aiDataContract, function(field, contract) {
          var isRequired = isFunction(contract) ? contract() & 1 : contract & 1;
          var isHidden = isFunction(contract) ? contract() & 4 : contract & 4;
          var isArray2 = contract & 2;
          var isPresent = source[field] !== void 0;
          var isObj = isObject(source[field]) && source[field] !== null;
          if (isRequired && !isPresent && !isArray2) {
            _throwInternal(logger, 1, 24, "Missing required field specification. The field is required but not present on source", { field, name });
          } else if (!isHidden) {
            var value = void 0;
            if (isObj) {
              if (isArray2) {
                value = _serializeArray(source[field], field);
              } else {
                value = _serializeObject(source[field], field);
              }
            } else {
              value = source[field];
            }
            if (value !== void 0) {
              output[field] = value;
            }
          }
        });
        delete source[circularReferenceCheck];
        return output;
      }
      function _serializeArray(sources, name) {
        var output;
        if (!!sources) {
          if (!isArray(sources)) {
            _throwInternal(logger, 1, 54, "This field was specified as an array in the contract but the item is not an array.\r\n", { name }, true);
          } else {
            output = [];
            for (var i = 0; i < sources[_DYN_LENGTH2]; i++) {
              var source = sources[i];
              var item = _serializeObject(source, name + "[" + i + "]");
              output[_DYN_PUSH](item);
            }
          }
        }
        return output;
      }
      function _serializeStringMap(map, expectedType, name) {
        var output;
        if (map) {
          output = {};
          objForEachKey(map, function(field, value) {
            if (expectedType === "string") {
              if (value === void 0) {
                output[field] = "undefined";
              } else if (value === null) {
                output[field] = "null";
              } else if (!value[_DYN_TO_STRING2]) {
                output[field] = "invalid field: toString() is not defined.";
              } else {
                output[field] = value[_DYN_TO_STRING2]();
              }
            } else if (expectedType === "number") {
              if (value === void 0) {
                output[field] = "undefined";
              } else if (value === null) {
                output[field] = "null";
              } else {
                var num = parseFloat(value);
                if (isNaN(num)) {
                  output[field] = "NaN";
                } else {
                  output[field] = num;
                }
              }
            } else {
              output[field] = "invalid field: " + name + " is of unknown type.";
              _throwInternal(logger, 1, output[field], null, true);
            }
          });
        }
        return output;
      }
    });
  }
  Serializer2.__ieDyn = 1;
  return Serializer2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/TelemetryProcessors/SamplingScoreGenerators/HashCodeScoreGenerator.js
var MIN_INPUT_LENGTH = 8;
var HashCodeScoreGenerator = function() {
  function HashCodeScoreGenerator2() {
  }
  HashCodeScoreGenerator2.prototype.getHashCodeScore = function(key) {
    var score = this.getHashCode(key) / HashCodeScoreGenerator2.INT_MAX_VALUE;
    return score * 100;
  };
  HashCodeScoreGenerator2.prototype.getHashCode = function(input) {
    if (input === "") {
      return 0;
    }
    while (input[_DYN_LENGTH2] < MIN_INPUT_LENGTH) {
      input = input.concat(input);
    }
    var hash = 5381;
    for (var i = 0; i < input[_DYN_LENGTH2]; ++i) {
      hash = (hash << 5) + hash + input.charCodeAt(i);
      hash = hash & hash;
    }
    return Math.abs(hash);
  };
  HashCodeScoreGenerator2.INT_MAX_VALUE = 2147483647;
  return HashCodeScoreGenerator2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/TelemetryProcessors/SamplingScoreGenerators/SamplingScoreGenerator.js
var SamplingScoreGenerator = function() {
  function SamplingScoreGenerator2() {
    var _self = this;
    var hashCodeGenerator = new HashCodeScoreGenerator();
    var keys = new ContextTagKeys();
    _self[_DYN_GET_SAMPLING_SCORE] = function(item) {
      var score = 0;
      if (item[_DYN_TAGS] && item[_DYN_TAGS][keys.userId]) {
        score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS][keys.userId]);
      } else if (item.ext && item.ext.user && item.ext.user.id) {
        score = hashCodeGenerator[_DYN_GET_HASH_CODE_SCORE](item.ext.user.id);
      } else if (item[_DYN_TAGS] && item[_DYN_TAGS][keys.operationId]) {
        score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS][keys.operationId]);
      } else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[_DYN_TRACE_ID]) {
        score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[_DYN_TRACE_ID]);
      } else {
        score = Math.random() * 100;
      }
      return score;
    };
  }
  return SamplingScoreGenerator2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/TelemetryProcessors/Sample.js
var Sample = function() {
  function Sample2(sampleRate, logger) {
    this.INT_MAX_VALUE = 2147483647;
    var _logger = logger || safeGetLogger(null);
    if (sampleRate > 100 || sampleRate < 0) {
      _logger.throwInternal(2, 58, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
      sampleRate = 100;
    }
    this[_DYN_SAMPLE_RATE] = sampleRate;
    this.samplingScoreGenerator = new SamplingScoreGenerator();
  }
  Sample2.prototype.isSampledIn = function(envelope) {
    var samplingPercentage = this[_DYN_SAMPLE_RATE];
    var isSampledIn = false;
    if (samplingPercentage === null || samplingPercentage === void 0 || samplingPercentage >= 100) {
      return true;
    } else if (envelope.baseType === Metric[_DYN_DATA_TYPE2]) {
      return true;
    }
    isSampledIn = this.samplingScoreGenerator[_DYN_GET_SAMPLING_SCORE](envelope) < samplingPercentage;
    return isSampledIn;
  };
  return Sample2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-channel-js@2.8.8/node_modules/@microsoft/applicationinsights-channel-js/dist-esm/Sender.js
var _a;
var FetchSyncRequestSizeLimitBytes = 65e3;
function _getResponseText(xhr) {
  try {
    return xhr.responseText;
  } catch (e) {
  }
  return null;
}
function _getDefaultAppInsightsChannelConfig() {
  var _a2;
  var defaultValue;
  var defaultCustomHeaders;
  return _a2 = {
    endpointUrl: function() {
      return DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH;
    }
  }, _a2[_DYN_EMIT_LINE_DELIMITED_0] = function() {
    return false;
  }, _a2[_DYN_MAX_BATCH_INTERVAL] = function() {
    return 15e3;
  }, _a2[_DYN_MAX_BATCH_SIZE_IN_BY1] = function() {
    return 102400;
  }, _a2[_DYN_DISABLE_TELEMETRY] = function() {
    return false;
  }, _a2[_DYN_ENABLE_SESSION_STORA4] = function() {
    return true;
  }, _a2[_DYN_IS_RETRY_DISABLED] = function() {
    return false;
  }, _a2[_DYN_IS_BEACON_API_DISABL3] = function() {
    return true;
  }, _a2[_DYN_DISABLE_XHR] = function() {
    return false;
  }, _a2[_DYN_ONUNLOAD_DISABLE_FET5] = function() {
    return false;
  }, _a2[_DYN_ONUNLOAD_DISABLE_BEA2] = function() {
    return false;
  }, _a2[_DYN_INSTRUMENTATION_KEY] = function() {
    return defaultValue;
  }, _a2[_DYN_NAME_PREFIX2] = function() {
    return defaultValue;
  }, _a2[_DYN_SAMPLING_PERCENTAGE2] = function() {
    return 100;
  }, _a2[_DYN_CUSTOM_HEADERS] = function() {
    return defaultCustomHeaders;
  }, _a2[_DYN_CONVERT_UNDEFINED] = function() {
    return defaultValue;
  }, _a2.eventsLimitInMem = function() {
    return 1e4;
  }, _a2;
}
var EnvelopeTypeCreator = (_a = {}, _a[Event2.dataType] = EventEnvelopeCreator, _a[Trace.dataType] = TraceEnvelopeCreator, _a[PageView.dataType] = PageViewEnvelopeCreator, _a[PageViewPerformance.dataType] = PageViewPerformanceEnvelopeCreator, _a[Exception.dataType] = ExceptionEnvelopeCreator, _a[Metric.dataType] = MetricEnvelopeCreator, _a[RemoteDependencyData.dataType] = DependencyEnvelopeCreator, _a);
var Sender = function(_super) {
  __extendsFn(Sender2, _super);
  function Sender2() {
    var _this = _super.call(this) || this;
    _this.priority = 1001;
    _this.identifier = BreezeChannelIdentifier;
    _this._senderConfig = _getDefaultAppInsightsChannelConfig();
    var _consecutiveErrors;
    var _retryAt;
    var _lastSend;
    var _paused;
    var _timeoutHandle;
    var _serializer;
    var _stamp_specific_redirects;
    var _headers;
    var _syncFetchPayload = 0;
    var _fallbackSender;
    var _syncUnloadSender;
    var _offlineListener;
    var _evtNamespace;
    dynamicProto(Sender2, _this, function(_self, _base) {
      _initDefaults();
      _self.pause = function() {
        _clearScheduledTimer();
        _paused = true;
      };
      _self.resume = function() {
        if (_paused) {
          _paused = false;
          _retryAt = null;
          if (_self._buffer.size() > _self._senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1]()) {
            _self[_DYN_TRIGGER_SEND](true, null, 10);
          }
          _setupTimer();
        }
      };
      _self.flush = function(isAsync, callBack, sendReason) {
        if (isAsync === void 0) {
          isAsync = true;
        }
        if (!_paused) {
          _clearScheduledTimer();
          try {
            _self[_DYN_TRIGGER_SEND](isAsync, null, sendReason || 1);
          } catch (e) {
            _throwInternal(_self[_DYN_DIAG_LOG2](), 1, 22, "flush failed, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
          }
        }
      };
      _self.onunloadFlush = function() {
        if (!_paused) {
          if ((_self._senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2]() === false || _self[_DYN__SENDER_CONFIG][_DYN_IS_BEACON_API_DISABL3]() === false) && isBeaconsSupported()) {
            try {
              _self[_DYN_TRIGGER_SEND](true, _doUnloadSend, 2);
            } catch (e) {
              _throwInternal(_self[_DYN_DIAG_LOG2](), 1, 20, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
            }
          } else {
            _self.flush();
          }
        }
      };
      _self.addHeader = function(name, value) {
        _headers[name] = value;
      };
      _self.initialize = function(config, core, extensions, pluginChain) {
        if (_self.isInitialized()) {
          _throwInternal(_self[_DYN_DIAG_LOG2](), 1, 28, "Sender is already initialized");
        }
        _base.initialize(config, core, extensions, pluginChain);
        var ctx = _self._getTelCtx();
        var identifier = _self.identifier;
        _serializer = new Serializer(core.logger);
        _consecutiveErrors = 0;
        _retryAt = null;
        _lastSend = 0;
        _self[_DYN__SENDER] = null;
        _stamp_specific_redirects = 0;
        var diagLog = _self[_DYN_DIAG_LOG2]();
        _evtNamespace = mergeEvtNamespace(createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
        _offlineListener = createOfflineListener(_evtNamespace);
        var defaultConfig = _getDefaultAppInsightsChannelConfig();
        objForEachKey(defaultConfig, function(field, value) {
          _self[_DYN__SENDER_CONFIG][field] = function() {
            var theValue = ctx.getConfig(identifier, field, value());
            if (!theValue && field === "endpointUrl") {
              theValue = value();
            }
            return theValue;
          };
        });
        _self._buffer = _self[_DYN__SENDER_CONFIG][_DYN_ENABLE_SESSION_STORA4]() && utlCanUseSessionStorage() ? new SessionStorageSendBuffer(diagLog, _self[_DYN__SENDER_CONFIG]) : new ArraySendBuffer(diagLog, _self[_DYN__SENDER_CONFIG]);
        _self._sample = new Sample(_self[_DYN__SENDER_CONFIG][_DYN_SAMPLING_PERCENTAGE2](), diagLog);
        if (!_validateInstrumentationKey(config)) {
          _throwInternal(diagLog, 1, 100, "Invalid Instrumentation key " + config[_DYN_INSTRUMENTATION_KEY]);
        }
        if (!isInternalApplicationInsightsEndpoint(_self._senderConfig.endpointUrl()) && _self._senderConfig.customHeaders() && _self._senderConfig.customHeaders()[_DYN_LENGTH2] > 0) {
          arrForEach(_self[_DYN__SENDER_CONFIG][_DYN_CUSTOM_HEADERS](), function(customHeader) {
            _this.addHeader(customHeader.header, customHeader.value);
          });
        }
        var senderConfig = _self[_DYN__SENDER_CONFIG];
        var sendPostFunc = null;
        if (!senderConfig[_DYN_DISABLE_XHR]() && useXDomainRequest()) {
          sendPostFunc = _xdrSender;
        } else if (!senderConfig[_DYN_DISABLE_XHR]() && isXhrSupported()) {
          sendPostFunc = _xhrSender;
        }
        if (!sendPostFunc && isFetchSupported()) {
          sendPostFunc = _fetchSender;
        }
        _fallbackSender = sendPostFunc || _xhrSender;
        if (!senderConfig[_DYN_IS_BEACON_API_DISABL3]() && isBeaconsSupported()) {
          sendPostFunc = _beaconSender;
        }
        _self[_DYN__SENDER] = sendPostFunc || _xhrSender;
        if (!senderConfig[_DYN_ONUNLOAD_DISABLE_FET5]() && isFetchSupported(true)) {
          _syncUnloadSender = _fetchKeepAliveSender;
        } else if (isBeaconsSupported()) {
          _syncUnloadSender = _beaconSender;
        } else if (!senderConfig[_DYN_DISABLE_XHR]() && useXDomainRequest()) {
          _syncUnloadSender = _xdrSender;
        } else if (!senderConfig[_DYN_DISABLE_XHR]() && isXhrSupported()) {
          _syncUnloadSender = _xhrSender;
        } else {
          _syncUnloadSender = _fallbackSender;
        }
      };
      _self.processTelemetry = function(telemetryItem, itemCtx) {
        itemCtx = _self._getTelCtx(itemCtx);
        var diagLogger = itemCtx[_DYN_DIAG_LOG2]();
        try {
          if (_self[_DYN__SENDER_CONFIG][_DYN_DISABLE_TELEMETRY]()) {
            return;
          }
          if (!telemetryItem) {
            _throwInternal(diagLogger, 1, 7, "Cannot send empty telemetry");
            return;
          }
          if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE]) {
            _throwInternal(diagLogger, 1, 70, "Cannot send telemetry without baseData and baseType");
            return;
          }
          if (!telemetryItem[_DYN_BASE_TYPE]) {
            telemetryItem[_DYN_BASE_TYPE] = "EventData";
          }
          if (!_self[_DYN__SENDER]) {
            _throwInternal(diagLogger, 1, 28, "Sender was not initialized");
            return;
          }
          if (!_isSampledIn(telemetryItem)) {
            _throwInternal(diagLogger, 2, 33, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[_DYN_SAMPLE_RATE] });
            return;
          } else {
            telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE];
          }
          var convertUndefined = _self[_DYN__SENDER_CONFIG][_DYN_CONVERT_UNDEFINED]() || void 0;
          var defaultEnvelopeIkey = telemetryItem.iKey || _self[_DYN__SENDER_CONFIG][_DYN_INSTRUMENTATION_KEY]();
          var aiEnvelope_1 = Sender2.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, convertUndefined);
          if (!aiEnvelope_1) {
            _throwInternal(diagLogger, 1, 47, "Unable to create an AppInsights envelope");
            return;
          }
          var doNotSendItem_1 = false;
          if (telemetryItem[_DYN_TAGS] && telemetryItem[_DYN_TAGS][ProcessLegacy]) {
            arrForEach(telemetryItem[_DYN_TAGS][ProcessLegacy], function(callBack) {
              try {
                if (callBack && callBack(aiEnvelope_1) === false) {
                  doNotSendItem_1 = true;
                  _warnToConsole(diagLogger, "Telemetry processor check returns false");
                }
              } catch (e) {
                _throwInternal(diagLogger, 1, 64, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
              }
            });
            delete telemetryItem[_DYN_TAGS][ProcessLegacy];
          }
          if (doNotSendItem_1) {
            return;
          }
          var payload = _serializer.serialize(aiEnvelope_1);
          var buffer = _self[_DYN__BUFFER];
          var bufferSize = buffer.size();
          if (bufferSize + payload[_DYN_LENGTH2] > _self[_DYN__SENDER_CONFIG][_DYN_MAX_BATCH_SIZE_IN_BY1]()) {
            _self[_DYN_TRIGGER_SEND](true, null, 10);
          }
          buffer[_DYN_ENQUEUE](payload);
          _setupTimer();
        } catch (e) {
          _throwInternal(diagLogger, 2, 12, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
        }
        _self.processNext(telemetryItem, itemCtx);
      };
      _self[_DYN__XHR_READY_STATE_CHA6] = function(xhr, payload, countOfItemsInPayload) {
        if (xhr.readyState === 4) {
          _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
        }
      };
      _self[_DYN_TRIGGER_SEND] = function(async, forcedSender, sendReason) {
        if (async === void 0) {
          async = true;
        }
        if (!_paused) {
          try {
            var buffer = _self[_DYN__BUFFER];
            if (!_self[_DYN__SENDER_CONFIG][_DYN_DISABLE_TELEMETRY]()) {
              if (buffer[_DYN_COUNT]() > 0) {
                var payload = buffer.getItems();
                _notifySendRequest(sendReason || 0, async);
                if (forcedSender) {
                  forcedSender.call(_this, payload, async);
                } else {
                  _self[_DYN__SENDER](payload, async);
                }
              }
              _lastSend = +new Date();
            } else {
              buffer[_DYN_CLEAR]();
            }
            _clearScheduledTimer();
          } catch (e) {
            var ieVer = getIEVersion();
            if (!ieVer || ieVer > 9) {
              _throwInternal(_self[_DYN_DIAG_LOG2](), 1, 40, "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
            }
          }
        }
      };
      _self._doTeardown = function(unloadCtx, unloadState) {
        _self.onunloadFlush();
        _offlineListener.unload();
        _initDefaults();
      };
      _self[_DYN__ON_ERROR] = function(payload, message, event) {
        _throwInternal(_self[_DYN_DIAG_LOG2](), 2, 26, "Failed to send telemetry.", { message });
        _self._buffer[_DYN_CLEAR_SENT](payload);
      };
      _self[_DYN__ON_PARTIAL_SUCCESS] = function(payload, results) {
        var failed = [];
        var retry = [];
        var errors = results.errors.reverse();
        for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
          var error = errors_1[_i];
          var extracted = payload.splice(error.index, 1)[0];
          if (_isRetriable(error.statusCode)) {
            retry[_DYN_PUSH](extracted);
          } else {
            failed[_DYN_PUSH](extracted);
          }
        }
        if (payload[_DYN_LENGTH2] > 0) {
          _self[_DYN__ON_SUCCESS](payload, results[_DYN_ITEMS_ACCEPTED]);
        }
        if (failed[_DYN_LENGTH2] > 0) {
          _self[_DYN__ON_ERROR](failed, _formatErrorMessageXhr(null, ["partial success", results[_DYN_ITEMS_ACCEPTED], "of", results.itemsReceived].join(" ")));
        }
        if (retry[_DYN_LENGTH2] > 0) {
          _resendPayload(retry);
          _throwInternal(_self[_DYN_DIAG_LOG2](), 2, 40, "Partial success. Delivered: " + payload[_DYN_LENGTH2] + ", Failed: " + failed[_DYN_LENGTH2] + ". Will retry to send " + retry[_DYN_LENGTH2] + " our of " + results[_DYN_ITEMS_RECEIVED] + " items");
        }
      };
      _self[_DYN__ON_SUCCESS] = function(payload, countOfItemsInPayload) {
        _self._buffer[_DYN_CLEAR_SENT](payload);
      };
      _self._xdrOnLoad = function(xdr, payload) {
        var responseText = _getResponseText(xdr);
        if (xdr && (responseText + "" === "200" || responseText === "")) {
          _consecutiveErrors = 0;
          _self[_DYN__ON_SUCCESS](payload, 0);
        } else {
          var results = _parseResponse(responseText);
          if (results && results.itemsReceived && results.itemsReceived > results[_DYN_ITEMS_ACCEPTED] && !_self[_DYN__SENDER_CONFIG][_DYN_IS_RETRY_DISABLED]()) {
            _self[_DYN__ON_PARTIAL_SUCCESS](payload, results);
          } else {
            _self[_DYN__ON_ERROR](payload, _formatErrorMessageXdr(xdr));
          }
        }
      };
      function _isSampledIn(envelope) {
        return _self._sample.isSampledIn(envelope);
      }
      function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
        var response = null;
        if (!_self._appId) {
          response = _parseResponse(res);
          if (response && response.appId) {
            _self._appId = response.appId;
          }
        }
        if ((status < 200 || status >= 300) && status !== 0) {
          if (status === 301 || status === 307 || status === 308) {
            if (!_checkAndUpdateEndPointUrl(responseUrl)) {
              _self[_DYN__ON_ERROR](payload, errorMessage);
              return;
            }
          }
          if (!_self[_DYN__SENDER_CONFIG][_DYN_IS_RETRY_DISABLED]() && _isRetriable(status)) {
            _resendPayload(payload);
            _throwInternal(_self[_DYN_DIAG_LOG2](), 2, 40, ". Response code " + status + ". Will retry to send " + payload[_DYN_LENGTH2] + " items.");
          } else {
            _self[_DYN__ON_ERROR](payload, errorMessage);
          }
        } else if (_offlineListener && !_offlineListener.isOnline()) {
          if (!_self[_DYN__SENDER_CONFIG][_DYN_IS_RETRY_DISABLED]()) {
            var offlineBackOffMultiplier = 10;
            _resendPayload(payload, offlineBackOffMultiplier);
            _throwInternal(_self[_DYN_DIAG_LOG2](), 2, 40, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
          }
        } else {
          _checkAndUpdateEndPointUrl(responseUrl);
          if (status === 206) {
            if (!response) {
              response = _parseResponse(res);
            }
            if (response && !_self[_DYN__SENDER_CONFIG][_DYN_IS_RETRY_DISABLED]()) {
              _self[_DYN__ON_PARTIAL_SUCCESS](payload, response);
            } else {
              _self[_DYN__ON_ERROR](payload, errorMessage);
            }
          } else {
            _consecutiveErrors = 0;
            _self[_DYN__ON_SUCCESS](payload, countOfItemsInPayload);
          }
        }
      }
      function _checkAndUpdateEndPointUrl(responseUrl) {
        if (_stamp_specific_redirects >= 10) {
          return false;
        }
        if (!isNullOrUndefined(responseUrl) && responseUrl !== "") {
          if (responseUrl !== _self[_DYN__SENDER_CONFIG][_DYN_ENDPOINT_URL]()) {
            _self[_DYN__SENDER_CONFIG][_DYN_ENDPOINT_URL] = function() {
              return responseUrl;
            };
            ++_stamp_specific_redirects;
            return true;
          }
        }
        return false;
      }
      function _doUnloadSend(payload, isAsync) {
        if (_syncUnloadSender) {
          _syncUnloadSender(payload, false);
        } else {
          _beaconSender(payload, isAsync);
        }
      }
      function _doBeaconSend(payload) {
        var nav = getNavigator();
        var buffer = _self[_DYN__BUFFER];
        var url = _self[_DYN__SENDER_CONFIG][_DYN_ENDPOINT_URL]();
        var batch = _self._buffer[_DYN_BATCH_PAYLOADS](payload);
        var plainTextBatch = new Blob([batch], { type: "text/plain;charset=UTF-8" });
        var queued = nav.sendBeacon(url, plainTextBatch);
        if (queued) {
          buffer[_DYN_MARK_AS_SENT](payload);
          _self._onSuccess(payload, payload[_DYN_LENGTH2]);
        }
        return queued;
      }
      function _beaconSender(payload, isAsync) {
        if (isArray(payload) && payload[_DYN_LENGTH2] > 0) {
          if (!_doBeaconSend(payload)) {
            var droppedPayload = [];
            for (var lp = 0; lp < payload[_DYN_LENGTH2]; lp++) {
              var thePayload = payload[lp];
              if (!_doBeaconSend([thePayload])) {
                droppedPayload[_DYN_PUSH](thePayload);
              }
            }
            if (droppedPayload[_DYN_LENGTH2] > 0) {
              _fallbackSender && _fallbackSender(droppedPayload, true);
              _throwInternal(_self[_DYN_DIAG_LOG2](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender.");
            }
          }
        }
      }
      function _xhrSender(payload, isAsync) {
        var xhr = new XMLHttpRequest();
        var endPointUrl = _self[_DYN__SENDER_CONFIG][_DYN_ENDPOINT_URL]();
        try {
          xhr[DisabledPropertyName] = true;
        } catch (e) {
        }
        xhr.open("POST", endPointUrl, isAsync);
        xhr[_DYN_SET_REQUEST_HEADER]("Content-type", "application/json");
        if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
          xhr[_DYN_SET_REQUEST_HEADER](RequestHeaders[6], RequestHeaders[7]);
        }
        arrForEach(objKeys(_headers), function(headerName) {
          xhr[_DYN_SET_REQUEST_HEADER](headerName, _headers[headerName]);
        });
        xhr.onreadystatechange = function() {
          return _self._xhrReadyStateChange(xhr, payload, payload[_DYN_LENGTH2]);
        };
        xhr.onerror = function(event) {
          return _self[_DYN__ON_ERROR](payload, _formatErrorMessageXhr(xhr), event);
        };
        var batch = _self._buffer[_DYN_BATCH_PAYLOADS](payload);
        xhr.send(batch);
        _self._buffer[_DYN_MARK_AS_SENT](payload);
      }
      function _fetchKeepAliveSender(payload, isAsync) {
        if (isArray(payload)) {
          var payloadSize = payload[_DYN_LENGTH2];
          for (var lp = 0; lp < payload[_DYN_LENGTH2]; lp++) {
            payloadSize += payload[lp][_DYN_LENGTH2];
          }
          if (_syncFetchPayload + payloadSize <= FetchSyncRequestSizeLimitBytes) {
            _doFetchSender(payload, false);
          } else if (isBeaconsSupported()) {
            _beaconSender(payload, isAsync);
          } else {
            _fallbackSender && _fallbackSender(payload, true);
            _throwInternal(_self[_DYN_DIAG_LOG2](), 2, 40, ". Failed to send telemetry with Beacon API, retried with xhrSender.");
          }
        }
      }
      function _fetchSender(payload, isAsync) {
        _doFetchSender(payload, true);
      }
      function _doFetchSender(payload, isAsync) {
        var _a2;
        var endPointUrl = _self[_DYN__SENDER_CONFIG][_DYN_ENDPOINT_URL]();
        var batch = _self._buffer[_DYN_BATCH_PAYLOADS](payload);
        var plainTextBatch = new Blob([batch], { type: "application/json" });
        var requestHeaders = new Headers();
        var batchLength = batch[_DYN_LENGTH2];
        var ignoreResponse = false;
        var responseHandled = false;
        if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
          requestHeaders.append(RequestHeaders[6], RequestHeaders[7]);
        }
        arrForEach(objKeys(_headers), function(headerName) {
          requestHeaders.append(headerName, _headers[headerName]);
        });
        var init = (_a2 = {
          method: "POST",
          headers: requestHeaders,
          body: plainTextBatch
        }, _a2[DisabledPropertyName] = true, _a2);
        if (!isAsync) {
          init.keepalive = true;
          ignoreResponse = true;
          _syncFetchPayload += batchLength;
        }
        var request = new Request(endPointUrl, init);
        try {
          request[DisabledPropertyName] = true;
        } catch (e) {
        }
        _self._buffer[_DYN_MARK_AS_SENT](payload);
        try {
          fetch(request).then(function(response) {
            if (!isAsync) {
              _syncFetchPayload -= batchLength;
              batchLength = 0;
            }
            if (!responseHandled) {
              responseHandled = true;
              if (!response.ok) {
                _self[_DYN__ON_ERROR](payload, response.statusText);
              } else {
                response.text().then(function(text) {
                  _checkResponsStatus(response.status, payload, response.url, payload[_DYN_LENGTH2], response.statusText, text);
                });
              }
            }
          })["catch"](function(error) {
            if (!isAsync) {
              _syncFetchPayload -= batchLength;
              batchLength = 0;
            }
            if (!responseHandled) {
              responseHandled = true;
              _self[_DYN__ON_ERROR](payload, error.message);
            }
          });
        } catch (e) {
          if (!responseHandled) {
            _self[_DYN__ON_ERROR](payload, dumpObj(e));
          }
        }
        if (ignoreResponse && !responseHandled) {
          responseHandled = true;
          _self._onSuccess(payload, payload[_DYN_LENGTH2]);
        }
      }
      function _parseResponse(response) {
        try {
          if (response && response !== "") {
            var result = getJSON().parse(response);
            if (result && result.itemsReceived && result.itemsReceived >= result[_DYN_ITEMS_ACCEPTED] && result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH2]) {
              return result;
            }
          }
        } catch (e) {
          _throwInternal(_self[_DYN_DIAG_LOG2](), 1, 43, "Cannot parse the response. " + getExceptionName(e), {
            response
          });
        }
        return null;
      }
      function _resendPayload(payload, linearFactor) {
        if (linearFactor === void 0) {
          linearFactor = 1;
        }
        if (!payload || payload[_DYN_LENGTH2] === 0) {
          return;
        }
        var buffer = _self[_DYN__BUFFER];
        buffer[_DYN_CLEAR_SENT](payload);
        _consecutiveErrors++;
        for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
          var item = payload_1[_i];
          buffer[_DYN_ENQUEUE](item);
        }
        _setRetryTime(linearFactor);
        _setupTimer();
      }
      function _setRetryTime(linearFactor) {
        var SlotDelayInSeconds = 10;
        var delayInSeconds;
        if (_consecutiveErrors <= 1) {
          delayInSeconds = SlotDelayInSeconds;
        } else {
          var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
          var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
          backOffDelay = linearFactor * backOffDelay;
          delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
        }
        var retryAfterTimeSpan = dateNow() + delayInSeconds * 1e3;
        _retryAt = retryAfterTimeSpan;
      }
      function _setupTimer() {
        if (!_timeoutHandle && !_paused) {
          var retryInterval = _retryAt ? Math.max(0, _retryAt - dateNow()) : 0;
          var timerValue = Math.max(_self[_DYN__SENDER_CONFIG][_DYN_MAX_BATCH_INTERVAL](), retryInterval);
          _timeoutHandle = setTimeout(function() {
            _timeoutHandle = null;
            _self[_DYN_TRIGGER_SEND](true, null, 1);
          }, timerValue);
        }
      }
      function _clearScheduledTimer() {
        clearTimeout(_timeoutHandle);
        _timeoutHandle = null;
        _retryAt = null;
      }
      function _isRetriable(statusCode) {
        return statusCode === 401 || statusCode === 403 || statusCode === 408 || statusCode === 429 || statusCode === 500 || statusCode === 502 || statusCode === 503 || statusCode === 504;
      }
      function _formatErrorMessageXhr(xhr, message) {
        if (xhr) {
          return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + _getResponseText(xhr) || xhr.response || "";
        }
        return message;
      }
      function _xdrSender(payload, isAsync) {
        var buffer = _self[_DYN__BUFFER];
        var _window = getWindow();
        var xdr = new XDomainRequest();
        xdr.onload = function() {
          return _self._xdrOnLoad(xdr, payload);
        };
        xdr.onerror = function(event) {
          return _self[_DYN__ON_ERROR](payload, _formatErrorMessageXdr(xdr), event);
        };
        var hostingProtocol = _window && _window.location && _window.location.protocol || "";
        if (_self[_DYN__SENDER_CONFIG][_DYN_ENDPOINT_URL]().lastIndexOf(hostingProtocol, 0) !== 0) {
          _throwInternal(_self[_DYN_DIAG_LOG2](), 2, 40, ". Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
          buffer[_DYN_CLEAR]();
          return;
        }
        var endpointUrl = _self[_DYN__SENDER_CONFIG][_DYN_ENDPOINT_URL]().replace(/^(https?:)/, "");
        xdr.open("POST", endpointUrl);
        var batch = buffer[_DYN_BATCH_PAYLOADS](payload);
        xdr.send(batch);
        buffer[_DYN_MARK_AS_SENT](payload);
      }
      function _formatErrorMessageXdr(xdr, message) {
        if (xdr) {
          return "XDomainRequest,Response:" + _getResponseText(xdr) || "";
        }
        return message;
      }
      function _getNotifyMgr() {
        var func = "getNotifyMgr";
        if (_self.core[func]) {
          return _self.core[func]();
        }
        return _self.core["_notificationManager"];
      }
      function _notifySendRequest(sendRequest, isAsync) {
        var manager = _getNotifyMgr();
        if (manager && manager[_DYN_EVENTS_SEND_REQUEST]) {
          try {
            manager[_DYN_EVENTS_SEND_REQUEST](sendRequest, isAsync);
          } catch (e) {
            _throwInternal(_self[_DYN_DIAG_LOG2](), 1, 74, "send request notification failed: " + getExceptionName(e), { exception: dumpObj(e) });
          }
        }
      }
      function _validateInstrumentationKey(config) {
        var disableIKeyValidationFlag = isNullOrUndefined(config[_DYN_DISABLE_INSTRUMENTAT7]) ? false : config[_DYN_DISABLE_INSTRUMENTAT7];
        if (disableIKeyValidationFlag) {
          return true;
        }
        var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
        var regexp = new RegExp(UUID_Regex);
        return regexp.test(config[_DYN_INSTRUMENTATION_KEY]);
      }
      function _initDefaults() {
        _self[_DYN__SENDER] = null;
        _self[_DYN__BUFFER] = null;
        _self._appId = null;
        _self._sample = null;
        _headers = {};
        _offlineListener = null;
        _consecutiveErrors = 0;
        _retryAt = null;
        _lastSend = null;
        _paused = false;
        _timeoutHandle = null;
        _serializer = null;
        _stamp_specific_redirects = 0;
        _syncFetchPayload = 0;
        _fallbackSender = null;
        _syncUnloadSender = null;
        _evtNamespace = null;
      }
    });
    return _this;
  }
  Sender2.constructEnvelope = function(orig, iKey, logger, convertUndefined) {
    var envelope;
    if (iKey !== orig.iKey && !isNullOrUndefined(iKey)) {
      envelope = __assignFn(__assignFn({}, orig), { iKey });
    } else {
      envelope = orig;
    }
    var creator = EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator;
    return creator(logger, envelope, convertUndefined);
  };
  return Sender2;
}(BaseTelemetryPlugin);

// node_modules/.pnpm/@microsoft+applicationinsights-dependencies-js@2.8.8/node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/InternalConstants.js
var STR_DURATION2 = "duration";
var STR_PROPERTIES = "properties";

// node_modules/.pnpm/@microsoft+applicationinsights-dependencies-js@2.8.8/node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/__DynamicConstants.js
var _DYN_REQUEST_URL = "requestUrl";
var _DYN_INST = "inst";
var _DYN_LENGTH3 = "length";
var _DYN_TRACE_ID2 = "traceID";
var _DYN_SPAN_ID = "spanID";
var _DYN_TRACE_FLAGS = "traceFlags";
var _DYN_CONTEXT = "context";
var _DYN_TRACE_ID0 = "traceId";
var _DYN_SPAN_ID1 = "spanId";
var _DYN_CORE2 = "core";
var _DYN_INCLUDE_CORRELATION_2 = "includeCorrelationHeaders";
var _DYN_CAN_INCLUDE_CORRELAT3 = "canIncludeCorrelationHeader";
var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl";
var _DYN_HEADERS = "headers";
var _DYN_REQUEST_HEADERS = "requestHeaders";
var _DYN_APP_ID = "appId";
var _DYN_SET_REQUEST_HEADER2 = "setRequestHeader";
var _DYN_TRACK_DEPENDENCY_DAT4 = "trackDependencyDataInternal";
var _DYN_DISTRIBUTED_TRACING_5 = "distributedTracingMode";
var _DYN_START_TIME = "startTime";
var _DYN_TO_LOWER_CASE = "toLowerCase";
var _DYN_ENABLE_REQUEST_HEADE6 = "enableRequestHeaderTracking";
var _DYN_ENABLE_AJAX_ERROR_ST7 = "enableAjaxErrorStatusText";
var _DYN_ENABLE_AJAX_PERF_TRA8 = "enableAjaxPerfTracking";
var _DYN_MAX_AJAX_CALLS_PER_V9 = "maxAjaxCallsPerView";
var _DYN_ENABLE_RESPONSE_HEAD10 = "enableResponseHeaderTracking";
var _DYN_EXCLUDE_REQUEST_FROM11 = "excludeRequestFromAutoTrackingPatterns";
var _DYN_ADD_REQUEST_CONTEXT = "addRequestContext";
var _DYN_DISABLE_AJAX_TRACKIN12 = "disableAjaxTracking";
var _DYN_DISABLE_FETCH_TRACKI13 = "disableFetchTracking";
var _DYN_STATUS = "status";
var _DYN_STATUS_TEXT = "statusText";
var _DYN_HEADER_MAP = "headerMap";
var _DYN_OPEN_DONE = "openDone";
var _DYN_SEND_DONE = "sendDone";
var _DYN_REQUEST_SENT_TIME = "requestSentTime";
var _DYN_ABORT_DONE = "abortDone";
var _DYN_GET_TRACE_ID = "getTraceId";
var _DYN_GET_TRACE_FLAGS = "getTraceFlags";
var _DYN_METHOD = "method";
var _DYN_ERROR_STATUS_TEXT = "errorStatusText";
var _DYN_STATE_CHANGE_ATTACHE14 = "stateChangeAttached";
var _DYN_RESPONSE_TEXT = "responseText";
var _DYN_RESPONSE_FINISHED_TI15 = "responseFinishedTime";
var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem";
var _DYN_RESPONSE = "response";
var _DYN_GET_ALL_RESPONSE_HEA16 = "getAllResponseHeaders";
var _DYN_GET_PART_APROPS = "getPartAProps";
var _DYN_GET_CORRELATION_CONT17 = "getCorrelationContext";
var _DYN_PERF_MARK = "perfMark";
var _DYN_AJAX_PERF_LOOKUP_DEL18 = "ajaxPerfLookupDelay";
var _DYN_NAME2 = "name";
var _DYN_PERF_TIMING = "perfTiming";
var _DYN_AJAX_DIAGNOSTICS_MES19 = "ajaxDiagnosticsMessage";
var _DYN_CORRELATION_CONTEXT = "correlationContext";
var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration";
var _DYN_EVENT_TRACE_CTX = "eventTraceCtx";

// node_modules/.pnpm/@microsoft+applicationinsights-dependencies-js@2.8.8/node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/ajaxRecord.js
function _calcPerfDuration(resourceEntry, start, end) {
  var result = 0;
  var from = resourceEntry[start];
  var to = resourceEntry[end];
  if (from && to) {
    result = dateTimeUtilsDuration(from, to);
  }
  return result;
}
function _setPerfDuration(props, name, resourceEntry, start, end) {
  var result = 0;
  var value = _calcPerfDuration(resourceEntry, start, end);
  if (value) {
    result = _setPerfValue(props, name, msToTimeSpan(value));
  }
  return result;
}
function _setPerfValue(props, name, value) {
  var strPerf = "ajaxPerf";
  var result = 0;
  if (props && name && value) {
    var perfData = props[strPerf] = props[strPerf] || {};
    perfData[name] = value;
    result = 1;
  }
  return result;
}
function _populatePerfData(ajaxData, dependency) {
  var resourceEntry = ajaxData[_DYN_PERF_TIMING];
  var props = dependency[STR_PROPERTIES] || {};
  var propsSet = 0;
  var strName = "name";
  var strStart = "Start";
  var strEnd = "End";
  var strDomainLookup = "domainLookup";
  var strConnect = "connect";
  var strRedirect = "redirect";
  var strRequest = "request";
  var strResponse = "response";
  var strStartTime = "startTime";
  var strDomainLookupStart = strDomainLookup + strStart;
  var strDomainLookupEnd = strDomainLookup + strEnd;
  var strConnectStart = strConnect + strStart;
  var strConnectEnd = strConnect + strEnd;
  var strRequestStart = strRequest + strStart;
  var strRequestEnd = strRequest + strEnd;
  var strResponseStart = strResponse + strStart;
  var strResponseEnd = strResponse + strEnd;
  var strRedirectStart = strRedirect + strStart;
  var strRedirectEnd = strRedirect = strEnd;
  var strTransferSize = "transferSize";
  var strEncodedBodySize = "encodedBodySize";
  var strDecodedBodySize = "decodedBodySize";
  var strServerTiming = "serverTiming";
  if (resourceEntry) {
    propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
    propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
    propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
    propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
    propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
    propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
    propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
    var duration = resourceEntry[STR_DURATION2];
    if (!duration) {
      duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
    }
    propsSet |= _setPerfValue(props, STR_DURATION2, duration);
    propsSet |= _setPerfValue(props, "perfTotal", duration);
    var serverTiming = resourceEntry[strServerTiming];
    if (serverTiming) {
      var server_1 = {};
      arrForEach(serverTiming, function(value, idx) {
        var name = normalizeJsName(value[strName] || "" + idx);
        var newValue = server_1[name] || {};
        objForEachKey(value, function(key, val) {
          if (key !== strName && isString(val) || isNumber(val)) {
            if (newValue[key]) {
              val = newValue[key] + ";" + val;
            }
            if (val || !isString(val)) {
              newValue[key] = val;
            }
          }
        });
        server_1[name] = newValue;
      });
      propsSet |= _setPerfValue(props, strServerTiming, server_1);
    }
    propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
    propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
    propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
  } else {
    if (ajaxData[_DYN_PERF_MARK]) {
      propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
    }
  }
  if (propsSet) {
    dependency[STR_PROPERTIES] = props;
  }
}
var XHRMonitoringState = function() {
  function XHRMonitoringState2() {
    var self = this;
    self[_DYN_OPEN_DONE] = false;
    self.setRequestHeaderDone = false;
    self[_DYN_SEND_DONE] = false;
    self[_DYN_ABORT_DONE] = false;
    self[_DYN_STATE_CHANGE_ATTACHE14] = false;
  }
  return XHRMonitoringState2;
}();
var ajaxRecord = function() {
  function ajaxRecord2(traceId, spanId, logger, traceCtx) {
    var _a2;
    var self = this;
    var _logger = logger;
    var strResponseText = "responseText";
    self[_DYN_PERF_MARK] = null;
    self.completed = false;
    self.requestHeadersSize = null;
    self[_DYN_REQUEST_HEADERS] = null;
    self.responseReceivingDuration = null;
    self.callbackDuration = null;
    self[_DYN_AJAX_TOTAL_DURATION] = null;
    self.aborted = 0;
    self.pageUrl = null;
    self[_DYN_REQUEST_URL] = null;
    self.requestSize = 0;
    self[_DYN_METHOD] = null;
    self[_DYN_STATUS] = null;
    self[_DYN_REQUEST_SENT_TIME] = null;
    self.responseStartedTime = null;
    self[_DYN_RESPONSE_FINISHED_TI15] = null;
    self.callbackFinishedTime = null;
    self.endTime = null;
    self.xhrMonitoringState = new XHRMonitoringState();
    self.clientFailure = 0;
    self[_DYN_TRACE_ID2] = traceId;
    self[_DYN_SPAN_ID] = spanId;
    self[_DYN_TRACE_FLAGS] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
    if (traceCtx) {
      self[_DYN_EVENT_TRACE_CTX] = (_a2 = {}, _a2[_DYN_TRACE_ID0] = traceCtx[_DYN_GET_TRACE_ID](), _a2[_DYN_SPAN_ID1] = traceCtx.getSpanId(), _a2[_DYN_TRACE_FLAGS] = traceCtx[_DYN_GET_TRACE_FLAGS](), _a2);
    } else {
      self[_DYN_EVENT_TRACE_CTX] = null;
    }
    dynamicProto(ajaxRecord2, self, function(self2) {
      self2.getAbsoluteUrl = function() {
        return self2[_DYN_REQUEST_URL] ? urlGetAbsoluteUrl(self2[_DYN_REQUEST_URL]) : null;
      };
      self2.getPathName = function() {
        return self2[_DYN_REQUEST_URL] ? dataSanitizeUrl(_logger, urlGetCompleteUrl(self2[_DYN_METHOD], self2[_DYN_REQUEST_URL])) : null;
      };
      self2[_DYN__CREATE_TRACK_ITEM] = function(ajaxType, enableRequestHeaderTracking, getResponse) {
        var _a3;
        self2.ajaxTotalDuration = Math.round(dateTimeUtilsDuration(self2.requestSentTime, self2.responseFinishedTime) * 1e3) / 1e3;
        if (self2[_DYN_AJAX_TOTAL_DURATION] < 0) {
          return null;
        }
        var dependency = (_a3 = {
          id: "|" + self2[_DYN_TRACE_ID2] + "." + self2[_DYN_SPAN_ID],
          target: self2[_DYN_GET_ABSOLUTE_URL]()
        }, _a3[_DYN_NAME2] = self2.getPathName(), _a3.type = ajaxType, _a3[_DYN_START_TIME] = null, _a3.duration = self2[_DYN_AJAX_TOTAL_DURATION], _a3.success = +self2[_DYN_STATUS] >= 200 && +self2[_DYN_STATUS] < 400, _a3.responseCode = +self2[_DYN_STATUS], _a3.method = self2[_DYN_METHOD], _a3[STR_PROPERTIES] = { HttpMethod: self2[_DYN_METHOD] }, _a3);
        if (self2[_DYN_REQUEST_SENT_TIME]) {
          dependency[_DYN_START_TIME] = new Date();
          dependency[_DYN_START_TIME].setTime(self2[_DYN_REQUEST_SENT_TIME]);
        }
        _populatePerfData(self2, dependency);
        if (enableRequestHeaderTracking) {
          if (objKeys(self2.requestHeaders)[_DYN_LENGTH3] > 0) {
            var props = dependency[STR_PROPERTIES] = dependency[STR_PROPERTIES] || {};
            props[_DYN_REQUEST_HEADERS] = self2[_DYN_REQUEST_HEADERS];
          }
        }
        if (getResponse) {
          var response = getResponse();
          if (response) {
            var correlationContext = response[_DYN_CORRELATION_CONTEXT];
            if (correlationContext) {
              dependency.correlationContext = correlationContext;
            }
            if (response[_DYN_HEADER_MAP]) {
              if (objKeys(response.headerMap)[_DYN_LENGTH3] > 0) {
                var props = dependency[STR_PROPERTIES] = dependency[STR_PROPERTIES] || {};
                props.responseHeaders = response[_DYN_HEADER_MAP];
              }
            }
            if (self2.errorStatusText && self2[_DYN_STATUS] >= 400) {
              var responseType = response.type;
              var props = dependency[STR_PROPERTIES] = dependency[STR_PROPERTIES] || {};
              if (responseType === "" || responseType === "text") {
                props.responseText = response.responseText ? response[_DYN_STATUS_TEXT] + " - " + response[strResponseText] : response[_DYN_STATUS_TEXT];
              }
              if (responseType === "json") {
                props.responseText = response.response ? response[_DYN_STATUS_TEXT] + " - " + JSON.stringify(response[_DYN_RESPONSE]) : response[_DYN_STATUS_TEXT];
              }
            }
          }
        }
        return dependency;
      };
      self2[_DYN_GET_PART_APROPS] = function() {
        var _a3;
        var partA = null;
        var traceCtx2 = self2[_DYN_EVENT_TRACE_CTX];
        if (traceCtx2 && (traceCtx2[_DYN_TRACE_ID0] || traceCtx2[_DYN_SPAN_ID1])) {
          partA = {};
          var traceExt = partA[Extensions.TraceExt] = (_a3 = {}, _a3[_DYN_TRACE_ID2] = traceCtx2[_DYN_TRACE_ID0], _a3.parentID = traceCtx2[_DYN_SPAN_ID1], _a3);
          if (!isNullOrUndefined(traceCtx2[_DYN_TRACE_FLAGS])) {
            traceExt[_DYN_TRACE_FLAGS] = traceCtx2[_DYN_TRACE_FLAGS];
          }
        }
        return partA;
      };
    });
  }
  ajaxRecord2.__ieDyn = 1;
  return ajaxRecord2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-dependencies-js@2.8.8/node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/ajax.js
var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var strAjaxData = "ajaxData";
var strFetch = "fetch";
var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var ERROR_PREFIX = ", monitoring data for this ajax call ";
var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
var _markCount = 0;
function _supportsFetch() {
  var _global = getGlobal();
  if (!_global || isNullOrUndefined(_global.Request) || isNullOrUndefined(_global.Request[strShimPrototype]) || isNullOrUndefined(_global[strFetch])) {
    return null;
  }
  return _global[strFetch];
}
function _supportsAjaxMonitoring(ajaxMonitorInstance) {
  var result = false;
  if (isXhrSupported()) {
    var proto = XMLHttpRequest[strShimPrototype];
    result = !isNullOrUndefined(proto) && !isNullOrUndefined(proto.open) && !isNullOrUndefined(proto.send) && !isNullOrUndefined(proto.abort);
  }
  var ieVer = getIEVersion();
  if (ieVer && ieVer < 9) {
    result = false;
  }
  if (result) {
    try {
      var xhr = new XMLHttpRequest();
      xhr[strAjaxData] = {};
      var theOpen = XMLHttpRequest[strShimPrototype].open;
      XMLHttpRequest[strShimPrototype].open = theOpen;
    } catch (e) {
      result = false;
      _throwInternalCritical(ajaxMonitorInstance, 15, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
        exception: dumpObj(e)
      });
    }
  }
  return result;
}
function _getFailedAjaxDiagnosticsMessage(xhr) {
  var result = "";
  try {
    if (xhr && xhr[strAjaxData] && xhr[strAjaxData][_DYN_REQUEST_URL]) {
      result += "(url: '" + xhr[strAjaxData][_DYN_REQUEST_URL] + "')";
    }
  } catch (e) {
  }
  return result;
}
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
  _throwInternal(ajaxMonitorInstance[strDiagLog](), 1, msgId, message, properties, isUserAct);
}
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
  _throwInternal(ajaxMonitorInstance[strDiagLog](), 2, msgId, message, properties, isUserAct);
}
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
  return function(args) {
    _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
      ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(args[_DYN_INST]),
      exception: dumpObj(args.err)
    });
  };
}
function _indexOf(value, match) {
  if (value && match) {
    return value.indexOf(match);
  }
  return -1;
}
function _addHandler(container, id, theFunc) {
  var theHandler = {
    id,
    fn: theFunc
  };
  container.push(theHandler);
  return {
    remove: function() {
      arrForEach(container, function(initializer, idx) {
        if (initializer.id === theHandler.id) {
          container.splice(idx, 1);
          return -1;
        }
      });
    }
  };
}
function _processDependencyContainer(core, container, details, message) {
  var result = true;
  arrForEach(container, function(theFunc, idx) {
    try {
      if (theFunc.fn.call(null, details) === false) {
        result = false;
      }
    } catch (e) {
      _throwInternal(core && core.logger, 1, 64, "Dependency " + message + " [#" + idx + "] failed: " + getExceptionName(e), { exception: dumpObj(e) }, true);
    }
  });
  return result;
}
function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
  var _a2;
  var initializersCount = listeners[_DYN_LENGTH3];
  if (initializersCount > 0) {
    var details = (_a2 = {}, _a2[_DYN_CORE2] = core, _a2.xhr = xhr, _a2.input = input, _a2.init = init, _a2.traceId = ajaxData[_DYN_TRACE_ID2], _a2.spanId = ajaxData[_DYN_SPAN_ID], _a2.traceFlags = ajaxData[_DYN_TRACE_FLAGS], _a2.context = ajaxData[_DYN_CONTEXT] || {}, _a2);
    _processDependencyContainer(core, listeners, details, "listener");
    ajaxData[_DYN_TRACE_ID2] = details[_DYN_TRACE_ID0];
    ajaxData[_DYN_SPAN_ID] = details[_DYN_SPAN_ID1];
    ajaxData[_DYN_TRACE_FLAGS] = details[_DYN_TRACE_FLAGS];
    ajaxData[_DYN_CONTEXT] = details[_DYN_CONTEXT];
  }
}
var BLOB_CORE = "*.blob.core.";
var DfltAjaxCorrelationHeaderExDomains = deepFreeze([
  BLOB_CORE + "windows.net",
  BLOB_CORE + "chinacloudapi.cn",
  BLOB_CORE + "cloudapi.de",
  BLOB_CORE + "usgovcloudapi.net"
]);
var _internalExcludeEndpoints = [
  /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
function _getDefaultConfig2() {
  var _a2;
  var config = (_a2 = {}, _a2[_DYN_MAX_AJAX_CALLS_PER_V9] = 500, _a2[_DYN_DISABLE_AJAX_TRACKIN12] = false, _a2[_DYN_DISABLE_FETCH_TRACKI13] = false, _a2[_DYN_EXCLUDE_REQUEST_FROM11] = void 0, _a2.disableCorrelationHeaders = false, _a2.distributedTracingMode = 1, _a2.correlationHeaderExcludedDomains = DfltAjaxCorrelationHeaderExDomains, _a2.correlationHeaderDomains = void 0, _a2.correlationHeaderExcludePatterns = void 0, _a2[_DYN_APP_ID] = void 0, _a2.enableCorsCorrelation = false, _a2[_DYN_ENABLE_REQUEST_HEADE6] = false, _a2[_DYN_ENABLE_RESPONSE_HEAD10] = false, _a2[_DYN_ENABLE_AJAX_ERROR_ST7] = false, _a2[_DYN_ENABLE_AJAX_PERF_TRA8] = false, _a2.maxAjaxPerfLookupAttempts = 3, _a2[_DYN_AJAX_PERF_LOOKUP_DEL18] = 25, _a2.ignoreHeaders = [
    "Authorization",
    "X-API-Key",
    "WWW-Authenticate"
  ], _a2[_DYN_ADD_REQUEST_CONTEXT] = void 0, _a2.addIntEndpoints = true, _a2);
  return config;
}
function _getEmptyConfig() {
  var emptyConfig = _getDefaultConfig2();
  objForEachKey(emptyConfig, function(value) {
    emptyConfig[value] = void 0;
  });
  return emptyConfig;
}
var AjaxMonitor = function(_super) {
  __extendsFn(AjaxMonitor2, _super);
  function AjaxMonitor2() {
    var _this = _super.call(this) || this;
    _this.identifier = AjaxMonitor2.identifier;
    _this.priority = 120;
    var _fetchInitialized;
    var _xhrInitialized;
    var _currentWindowHost;
    var _config;
    var _enableRequestHeaderTracking;
    var _enableAjaxErrorStatusText;
    var _trackAjaxAttempts;
    var _context;
    var _isUsingW3CHeaders;
    var _isUsingAIHeaders;
    var _markPrefix;
    var _enableAjaxPerfTracking;
    var _maxAjaxCallsPerView;
    var _enableResponseHeaderTracking;
    var _disabledUrls;
    var _disableAjaxTracking;
    var _disableFetchTracking;
    var _excludeRequestFromAutoTrackingPatterns;
    var _addRequestContext;
    var _evtNamespace;
    var _dependencyHandlerId;
    var _dependencyListeners;
    var _dependencyInitializers;
    dynamicProto(AjaxMonitor2, _this, function(_self, _base) {
      var _addHook = _base._addHook;
      _initDefaults();
      _self.initialize = function(config, core, extensions, pluginChain) {
        if (!_self.isInitialized()) {
          _base.initialize(config, core, extensions, pluginChain);
          _evtNamespace = mergeEvtNamespace(createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
          _populateDefaults(config);
          _instrumentXhr();
          _instrumentFetch();
          _populateContext();
        }
      };
      _self._doTeardown = function() {
        _initDefaults();
      };
      _self.trackDependencyData = function(dependency, properties) {
        _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE2], null, dependency, properties);
      };
      _self[_DYN_INCLUDE_CORRELATION_2] = function(ajaxData, input, init, xhr) {
        var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
        _processDependencyListeners(_dependencyListeners, _self[_DYN_CORE2], ajaxData, xhr, input, init);
        if (input) {
          if (CorrelationIdHelper[_DYN_CAN_INCLUDE_CORRELAT3](_config, ajaxData[_DYN_GET_ABSOLUTE_URL](), currentWindowHost)) {
            if (!init) {
              init = {};
            }
            var headers = new Headers(init[_DYN_HEADERS] || (input instanceof Request ? input[_DYN_HEADERS] || {} : {}));
            if (_isUsingAIHeaders) {
              var id = "|" + ajaxData[_DYN_TRACE_ID2] + "." + ajaxData[_DYN_SPAN_ID];
              headers.set(RequestHeaders[3], id);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[3]] = id;
              }
            }
            var appId = _config[_DYN_APP_ID] || _context && _context[_DYN_APP_ID]();
            if (appId) {
              headers.set(RequestHeaders[0], RequestHeaders[2] + appId);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[0]] = RequestHeaders[2] + appId;
              }
            }
            if (_isUsingW3CHeaders) {
              var traceFlags = ajaxData[_DYN_TRACE_FLAGS];
              if (isNullOrUndefined(traceFlags)) {
                traceFlags = 1;
              }
              var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID2], ajaxData[_DYN_SPAN_ID], traceFlags));
              headers.set(RequestHeaders[4], traceParent);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[4]] = traceParent;
              }
            }
            init[_DYN_HEADERS] = headers;
          }
          return init;
        } else if (xhr) {
          if (CorrelationIdHelper[_DYN_CAN_INCLUDE_CORRELAT3](_config, ajaxData[_DYN_GET_ABSOLUTE_URL](), currentWindowHost)) {
            if (_isUsingAIHeaders) {
              var id = "|" + ajaxData[_DYN_TRACE_ID2] + "." + ajaxData[_DYN_SPAN_ID];
              xhr[_DYN_SET_REQUEST_HEADER2](RequestHeaders[3], id);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[3]] = id;
              }
            }
            var appId = _config[_DYN_APP_ID] || _context && _context[_DYN_APP_ID]();
            if (appId) {
              xhr[_DYN_SET_REQUEST_HEADER2](RequestHeaders[0], RequestHeaders[2] + appId);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[0]] = RequestHeaders[2] + appId;
              }
            }
            if (_isUsingW3CHeaders) {
              var traceFlags = ajaxData[_DYN_TRACE_FLAGS];
              if (isNullOrUndefined(traceFlags)) {
                traceFlags = 1;
              }
              var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID2], ajaxData[_DYN_SPAN_ID], traceFlags));
              xhr[_DYN_SET_REQUEST_HEADER2](RequestHeaders[4], traceParent);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[4]] = traceParent;
              }
            }
          }
          return xhr;
        }
        return void 0;
      };
      _self[_DYN_TRACK_DEPENDENCY_DAT4] = function(dependency, properties, systemProperties) {
        if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
          if ((_config[_DYN_DISTRIBUTED_TRACING_5] === 2 || _config[_DYN_DISTRIBUTED_TRACING_5] === 1) && typeof dependency.id === "string" && dependency.id[dependency.id[_DYN_LENGTH3] - 1] !== ".") {
            dependency.id += ".";
          }
          if (isNullOrUndefined(dependency[_DYN_START_TIME])) {
            dependency[_DYN_START_TIME] = new Date();
          }
          var item = createTelemetryItem(dependency, RemoteDependencyData.dataType, RemoteDependencyData.envelopeType, _self[strDiagLog](), properties, systemProperties);
          _self[_DYN_CORE2].track(item);
        } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
          _throwInternalCritical(_self, 55, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
        }
        ++_trackAjaxAttempts;
      };
      _self.addDependencyListener = function(dependencyListener) {
        return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
      };
      _self.addDependencyInitializer = function(dependencyInitializer) {
        return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
      };
      function _initDefaults() {
        var location = getLocation();
        _fetchInitialized = false;
        _xhrInitialized = false;
        _currentWindowHost = location && location.host && location.host[_DYN_TO_LOWER_CASE]();
        _config = AjaxMonitor2.getEmptyConfig();
        _enableRequestHeaderTracking = false;
        _enableAjaxErrorStatusText = false;
        _trackAjaxAttempts = 0;
        _context = null;
        _isUsingW3CHeaders = false;
        _isUsingAIHeaders = false;
        _markPrefix = null;
        _enableAjaxPerfTracking = false;
        _maxAjaxCallsPerView = 0;
        _enableResponseHeaderTracking = false;
        _disabledUrls = {};
        _disableAjaxTracking = false;
        _disableFetchTracking = false;
        _excludeRequestFromAutoTrackingPatterns = null;
        _addRequestContext = null;
        _evtNamespace = null;
        _dependencyHandlerId = 0;
        _dependencyListeners = [];
        _dependencyInitializers = [];
      }
      function _populateDefaults(config) {
        var ctx = createProcessTelemetryContext(null, config, _self[_DYN_CORE2]);
        _config = _getEmptyConfig();
        var defaultConfig = _getDefaultConfig2();
        objForEachKey(defaultConfig, function(field, value) {
          _config[field] = ctx.getConfig(AjaxMonitor2.identifier, field, value);
        });
        var distributedTracingMode = _config[_DYN_DISTRIBUTED_TRACING_5];
        _enableRequestHeaderTracking = _config[_DYN_ENABLE_REQUEST_HEADE6];
        _enableAjaxErrorStatusText = _config[_DYN_ENABLE_AJAX_ERROR_ST7];
        _enableAjaxPerfTracking = _config[_DYN_ENABLE_AJAX_PERF_TRA8];
        _maxAjaxCallsPerView = _config[_DYN_MAX_AJAX_CALLS_PER_V9];
        _enableResponseHeaderTracking = _config[_DYN_ENABLE_RESPONSE_HEAD10];
        _excludeRequestFromAutoTrackingPatterns = [].concat(_config[_DYN_EXCLUDE_REQUEST_FROM11] || [], _config.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
        _addRequestContext = _config[_DYN_ADD_REQUEST_CONTEXT];
        _isUsingAIHeaders = distributedTracingMode === 0 || distributedTracingMode === 1;
        _isUsingW3CHeaders = distributedTracingMode === 1 || distributedTracingMode === 2;
        if (_enableAjaxPerfTracking) {
          var iKey = config.instrumentationKey || "unkwn";
          if (iKey[_DYN_LENGTH3] > 5) {
            _markPrefix = AJAX_MONITOR_PREFIX + iKey.substring(iKey[_DYN_LENGTH3] - 5) + ".";
          } else {
            _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
          }
        }
        _disableAjaxTracking = !!_config[_DYN_DISABLE_AJAX_TRACKIN12];
        _disableFetchTracking = !!_config[_DYN_DISABLE_FETCH_TRACKI13];
      }
      function _populateContext() {
        var propExt = _self[_DYN_CORE2].getPlugin(PropertiesPluginIdentifier);
        if (propExt) {
          _context = propExt.plugin[_DYN_CONTEXT];
        }
      }
      function _canIncludeHeaders(header) {
        var rlt = true;
        if (header || _config.ignoreHeaders) {
          arrForEach(_config.ignoreHeaders, function(key) {
            if (key[_DYN_TO_LOWER_CASE]() === header[_DYN_TO_LOWER_CASE]()) {
              rlt = false;
              return -1;
            }
          });
        }
        return rlt;
      }
      function _instrumentFetch() {
        var fetch2 = _supportsFetch();
        if (!fetch2) {
          return;
        }
        var global = getGlobal();
        var isPolyfill = fetch2.polyfill;
        if (!_disableFetchTracking && !_fetchInitialized) {
          _addHook(InstrumentFunc(global, strFetch, {
            ns: _evtNamespace,
            req: function(callDetails, input, init) {
              var fetchData;
              if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && !(isPolyfill && _xhrInitialized)) {
                var ctx = callDetails.ctx();
                fetchData = _createFetchRecord(input, init);
                var newInit = _self[_DYN_INCLUDE_CORRELATION_2](fetchData, input, init);
                if (newInit !== init) {
                  callDetails.set(1, newInit);
                }
                ctx.data = fetchData;
              }
            },
            rsp: function(callDetails, input) {
              if (!_disableFetchTracking) {
                var fetchData_1 = callDetails.ctx().data;
                if (fetchData_1) {
                  callDetails.rslt = callDetails.rslt.then(function(response) {
                    _reportFetchMetrics(callDetails, (response || {})[_DYN_STATUS], input, response, fetchData_1, function() {
                      var _a2;
                      var ajaxResponse = (_a2 = {
                        statusText: response[_DYN_STATUS_TEXT]
                      }, _a2[_DYN_HEADER_MAP] = null, _a2[_DYN_CORRELATION_CONTEXT] = _getFetchCorrelationContext(response), _a2);
                      if (_enableResponseHeaderTracking) {
                        var responseHeaderMap_1 = {};
                        response.headers.forEach(function(value, name) {
                          if (_canIncludeHeaders(name)) {
                            responseHeaderMap_1[name] = value;
                          }
                        });
                        ajaxResponse[_DYN_HEADER_MAP] = responseHeaderMap_1;
                      }
                      return ajaxResponse;
                    });
                    return response;
                  })["catch"](function(reason) {
                    _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, { error: reason.message });
                    throw reason;
                  });
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 15, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
          }));
          _fetchInitialized = true;
        } else if (isPolyfill) {
          _addHook(InstrumentFunc(global, strFetch, {
            ns: _evtNamespace,
            req: function(callDetails, input, init) {
              _isDisabledRequest(null, input, init);
            }
          }));
        }
        if (isPolyfill) {
          global[strFetch].polyfill = isPolyfill;
        }
      }
      function _hookProto(target, funcName, callbacks) {
        _addHook(InstrumentProto(target, funcName, callbacks));
      }
      function _instrumentXhr() {
        if (_supportsAjaxMonitoring(_self) && !_disableAjaxTracking && !_xhrInitialized) {
          _hookProto(XMLHttpRequest, "open", {
            ns: _evtNamespace,
            req: function(args, method, url, async) {
              if (!_disableAjaxTracking) {
                var xhr = args[_DYN_INST];
                var ajaxData = xhr[strAjaxData];
                if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, true)) {
                  if (!ajaxData || !ajaxData.xhrMonitoringState[_DYN_OPEN_DONE]) {
                    _openHandler(xhr, method, url, async);
                  }
                  _attachToOnReadyStateChange(xhr);
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 15, ERROR_HEADER + ".open" + ERROR_POSTFIX)
          });
          _hookProto(XMLHttpRequest, "send", {
            ns: _evtNamespace,
            req: function(args, context) {
              if (!_disableAjaxTracking) {
                var xhr = args[_DYN_INST];
                var ajaxData = xhr[strAjaxData];
                if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[_DYN_SEND_DONE]) {
                  _createMarkId("xhr", ajaxData);
                  ajaxData[_DYN_REQUEST_SENT_TIME] = dateTimeUtilsNow();
                  _self[_DYN_INCLUDE_CORRELATION_2](ajaxData, void 0, void 0, xhr);
                  ajaxData.xhrMonitoringState[_DYN_SEND_DONE] = true;
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 17, ERROR_HEADER + ERROR_POSTFIX)
          });
          _hookProto(XMLHttpRequest, "abort", {
            ns: _evtNamespace,
            req: function(args) {
              if (!_disableAjaxTracking) {
                var xhr = args[_DYN_INST];
                var ajaxData = xhr[strAjaxData];
                if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[_DYN_ABORT_DONE]) {
                  ajaxData.aborted = 1;
                  ajaxData.xhrMonitoringState[_DYN_ABORT_DONE] = true;
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 13, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
          });
          _hookProto(XMLHttpRequest, "setRequestHeader", {
            ns: _evtNamespace,
            req: function(args, header, value) {
              if (!_disableAjaxTracking && _enableRequestHeaderTracking) {
                var xhr = args[_DYN_INST];
                if (_isMonitoredXhrInstance(xhr) && _canIncludeHeaders(header)) {
                  xhr[strAjaxData][_DYN_REQUEST_HEADERS][header] = value;
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 71, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
          });
          _xhrInitialized = true;
        }
      }
      function _isDisabledRequest(xhr, request, init) {
        var isDisabled = false;
        var theUrl = ((!isString(request) ? (request || {}).url || "" : request) || "")[_DYN_TO_LOWER_CASE]();
        arrForEach(_excludeRequestFromAutoTrackingPatterns, function(regex) {
          var theRegex = regex;
          if (isString(regex)) {
            theRegex = new RegExp(regex);
          }
          if (!isDisabled) {
            isDisabled = theRegex.test(theUrl);
          }
        });
        if (isDisabled) {
          return isDisabled;
        }
        var idx = _indexOf(theUrl, "?");
        var idx2 = _indexOf(theUrl, "#");
        if (idx === -1 || idx2 !== -1 && idx2 < idx) {
          idx = idx2;
        }
        if (idx !== -1) {
          theUrl = theUrl.substring(0, idx);
        }
        if (!isNullOrUndefined(xhr)) {
          isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
        } else if (!isNullOrUndefined(request)) {
          isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) || (init ? init[DisabledPropertyName] === true : false);
        }
        if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) {
          isDisabled = true;
        }
        if (isDisabled) {
          if (!_disabledUrls[theUrl]) {
            _disabledUrls[theUrl] = 1;
          }
        } else {
          if (_disabledUrls[theUrl]) {
            isDisabled = true;
          }
        }
        return isDisabled;
      }
      function _isMonitoredXhrInstance(xhr, excludeAjaxDataValidation) {
        var ajaxValidation = true;
        var initialized = _xhrInitialized;
        if (!isNullOrUndefined(xhr)) {
          ajaxValidation = excludeAjaxDataValidation === true || !isNullOrUndefined(xhr[strAjaxData]);
        }
        return initialized && ajaxValidation;
      }
      function _getDistributedTraceCtx() {
        var distributedTraceCtx = null;
        if (_self[_DYN_CORE2] && _self[_DYN_CORE2].getTraceCtx) {
          distributedTraceCtx = _self[_DYN_CORE2].getTraceCtx(false);
        }
        if (!distributedTraceCtx && _context && _context.telemetryTrace) {
          distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
        }
        return distributedTraceCtx;
      }
      function _openHandler(xhr, method, url, async) {
        var _a2;
        var distributedTraceCtx = _getDistributedTraceCtx();
        var traceID = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID]() || generateW3CId();
        var spanID = generateW3CId().substr(0, 16);
        var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a2 = _self.core) === null || _a2 === void 0 ? void 0 : _a2.getTraceCtx());
        ajaxData[_DYN_TRACE_FLAGS] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS]();
        ajaxData[_DYN_METHOD] = method;
        ajaxData[_DYN_REQUEST_URL] = url;
        ajaxData.xhrMonitoringState[_DYN_OPEN_DONE] = true;
        ajaxData[_DYN_REQUEST_HEADERS] = {};
        ajaxData.async = async;
        ajaxData[_DYN_ERROR_STATUS_TEXT] = _enableAjaxErrorStatusText;
        xhr[strAjaxData] = ajaxData;
      }
      function _attachToOnReadyStateChange(xhr) {
        xhr[strAjaxData].xhrMonitoringState[_DYN_STATE_CHANGE_ATTACHE14] = eventOn(xhr, "readystatechange", function() {
          var _a2;
          try {
            if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr)) {
              _onAjaxComplete(xhr);
            }
          } catch (e) {
            var exceptionText = dumpObj(e);
            if (!exceptionText || _indexOf(exceptionText[_DYN_TO_LOWER_CASE](), "c00c023f") === -1) {
              _throwInternalCritical(_self, 16, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, (_a2 = {}, _a2[_DYN_AJAX_DIAGNOSTICS_MES19] = _getFailedAjaxDiagnosticsMessage(xhr), _a2.exception = exceptionText, _a2));
            }
          }
        }, _evtNamespace);
      }
      function _getResponseText2(xhr) {
        try {
          var responseType = xhr.responseType;
          if (responseType === "" || responseType === "text") {
            return xhr[_DYN_RESPONSE_TEXT];
          }
        } catch (e) {
        }
        return null;
      }
      function _onAjaxComplete(xhr) {
        var ajaxData = xhr[strAjaxData];
        ajaxData[_DYN_RESPONSE_FINISHED_TI15] = dateTimeUtilsNow();
        ajaxData[_DYN_STATUS] = xhr[_DYN_STATUS];
        function _reportXhrError(e, failedProps) {
          var errorProps = failedProps || {};
          errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr);
          if (e) {
            errorProps["exception"] = dumpObj(e);
          }
          _throwInternalWarning(_self, 14, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
        }
        _findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
          try {
            var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM]("Ajax", _enableRequestHeaderTracking, function() {
              var _a2;
              var ajaxResponse = (_a2 = {
                statusText: xhr[_DYN_STATUS_TEXT]
              }, _a2[_DYN_HEADER_MAP] = null, _a2[_DYN_CORRELATION_CONTEXT] = _getAjaxCorrelationContext(xhr), _a2.type = xhr.responseType, _a2[_DYN_RESPONSE_TEXT] = _getResponseText2(xhr), _a2.response = xhr[_DYN_RESPONSE], _a2);
              if (_enableResponseHeaderTracking) {
                var headers = xhr[_DYN_GET_ALL_RESPONSE_HEA16]();
                if (headers) {
                  var arr = strTrim(headers).split(/[\r\n]+/);
                  var responseHeaderMap_2 = {};
                  arrForEach(arr, function(line) {
                    var parts = line.split(": ");
                    var header = parts.shift();
                    var value = parts.join(": ");
                    if (_canIncludeHeaders(header)) {
                      responseHeaderMap_2[header] = value;
                    }
                  });
                  ajaxResponse[_DYN_HEADER_MAP] = responseHeaderMap_2;
                }
              }
              return ajaxResponse;
            });
            var properties = void 0;
            try {
              if (!!_addRequestContext) {
                properties = _addRequestContext({ status: xhr[_DYN_STATUS], xhr });
              }
            } catch (e) {
              _throwInternalWarning(_self, 104, CUSTOM_REQUEST_CONTEXT_ERROR);
            }
            if (dependency) {
              if (properties !== void 0) {
                dependency[STR_PROPERTIES] = __assignFn(__assignFn({}, dependency.properties), properties);
              }
              var sysProperties = ajaxData[_DYN_GET_PART_APROPS]();
              _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE2], ajaxData, dependency, null, sysProperties);
            } else {
              _reportXhrError(null, {
                requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME],
                responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI15]
              });
            }
          } finally {
            try {
              xhr[strAjaxData] = null;
            } catch (e) {
            }
          }
        }, function(e) {
          _reportXhrError(e, null);
        });
      }
      function _getAjaxCorrelationContext(xhr) {
        var _a2;
        try {
          var responseHeadersString = xhr[_DYN_GET_ALL_RESPONSE_HEA16]();
          if (responseHeadersString !== null) {
            var index = _indexOf(responseHeadersString[_DYN_TO_LOWER_CASE](), RequestHeaders[8]);
            if (index !== -1) {
              var responseHeader = xhr.getResponseHeader(RequestHeaders[0]);
              return CorrelationIdHelper[_DYN_GET_CORRELATION_CONT17](responseHeader);
            }
          }
        } catch (e) {
          _throwInternalWarning(_self, 18, CORRELATION_HEADER_ERROR, (_a2 = {}, _a2[_DYN_AJAX_DIAGNOSTICS_MES19] = _getFailedAjaxDiagnosticsMessage(xhr), _a2.exception = dumpObj(e), _a2));
        }
      }
      function _createMarkId(type, ajaxData) {
        if (ajaxData[_DYN_REQUEST_URL] && _markPrefix && _enableAjaxPerfTracking) {
          var performance_1 = getPerformance();
          if (performance_1 && isFunction(performance_1.mark)) {
            _markCount++;
            var markId = _markPrefix + type + "#" + _markCount;
            performance_1.mark(markId);
            var entries = performance_1.getEntriesByName(markId);
            if (entries && entries[_DYN_LENGTH3] === 1) {
              ajaxData[_DYN_PERF_MARK] = entries[0];
            }
          }
        }
      }
      function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
        var perfMark = ajaxData[_DYN_PERF_MARK];
        var performance = getPerformance();
        var maxAttempts = _config.maxAjaxPerfLookupAttempts;
        var retryDelay = _config[_DYN_AJAX_PERF_LOOKUP_DEL18];
        var requestUrl = ajaxData[_DYN_REQUEST_URL];
        var attempt = 0;
        (function locateResourceTiming() {
          try {
            if (performance && perfMark) {
              attempt++;
              var perfTiming = null;
              var entries = performance.getEntries();
              for (var lp = entries[_DYN_LENGTH3] - 1; lp >= 0; lp--) {
                var entry = entries[lp];
                if (entry) {
                  if (entry.entryType === "resource") {
                    if (entry.initiatorType === initiatorType && (_indexOf(entry[_DYN_NAME2], requestUrl) !== -1 || _indexOf(requestUrl, entry[_DYN_NAME2]) !== -1)) {
                      perfTiming = entry;
                    }
                  } else if (entry.entryType === "mark" && entry[_DYN_NAME2] === perfMark[_DYN_NAME2]) {
                    ajaxData[_DYN_PERF_TIMING] = perfTiming;
                    break;
                  }
                  if (entry[_DYN_START_TIME] < perfMark[_DYN_START_TIME] - 1e3) {
                    break;
                  }
                }
              }
            }
            if (!perfMark || ajaxData[_DYN_PERF_TIMING] || attempt >= maxAttempts || ajaxData.async === false) {
              if (perfMark && isFunction(performance.clearMarks)) {
                performance.clearMarks(perfMark[_DYN_NAME2]);
              }
              ajaxData.perfAttempts = attempt;
              trackCallback();
            } else {
              setTimeout(locateResourceTiming, retryDelay);
            }
          } catch (e) {
            reportError(e);
          }
        })();
      }
      function _createFetchRecord(input, init) {
        var _a2;
        var distributedTraceCtx = _getDistributedTraceCtx();
        var traceID = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID]() || generateW3CId();
        var spanID = generateW3CId().substr(0, 16);
        var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a2 = _self.core) === null || _a2 === void 0 ? void 0 : _a2.getTraceCtx());
        ajaxData[_DYN_TRACE_FLAGS] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS]();
        ajaxData[_DYN_REQUEST_SENT_TIME] = dateTimeUtilsNow();
        ajaxData[_DYN_ERROR_STATUS_TEXT] = _enableAjaxErrorStatusText;
        if (input instanceof Request) {
          ajaxData[_DYN_REQUEST_URL] = input ? input.url : "";
        } else {
          ajaxData[_DYN_REQUEST_URL] = input;
        }
        var method = "GET";
        if (init && init[_DYN_METHOD]) {
          method = init[_DYN_METHOD];
        } else if (input && input instanceof Request) {
          method = input[_DYN_METHOD];
        }
        ajaxData[_DYN_METHOD] = method;
        var requestHeaders = {};
        if (_enableRequestHeaderTracking) {
          var headers = new Headers((init ? init[_DYN_HEADERS] : 0) || (input instanceof Request ? input[_DYN_HEADERS] || {} : {}));
          headers.forEach(function(value, key) {
            if (_canIncludeHeaders(key)) {
              requestHeaders[key] = value;
            }
          });
        }
        ajaxData[_DYN_REQUEST_HEADERS] = requestHeaders;
        _createMarkId("fetch", ajaxData);
        return ajaxData;
      }
      function _getFailedFetchDiagnosticsMessage(input) {
        var result = "";
        try {
          if (!isNullOrUndefined(input)) {
            if (typeof input === "string") {
              result += "(url: '".concat(input, "')");
            } else {
              result += "(url: '".concat(input.url, "')");
            }
          }
        } catch (e) {
          _throwInternalCritical(_self, 15, "Failed to grab failed fetch diagnostics message", { exception: dumpObj(e) });
        }
        return result;
      }
      function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
        if (!ajaxData) {
          return;
        }
        function _reportFetchError(msgId, e, failedProps) {
          var errorProps = failedProps || {};
          errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
          if (e) {
            errorProps["exception"] = dumpObj(e);
          }
          _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
        }
        ajaxData[_DYN_RESPONSE_FINISHED_TI15] = dateTimeUtilsNow();
        ajaxData[_DYN_STATUS] = status;
        _findPerfResourceEntry("fetch", ajaxData, function() {
          var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM]("Fetch", _enableRequestHeaderTracking, getResponse);
          var properties2;
          try {
            if (!!_addRequestContext) {
              properties2 = _addRequestContext({ status, request: input, response });
            }
          } catch (e) {
            _throwInternalWarning(_self, 104, CUSTOM_REQUEST_CONTEXT_ERROR);
          }
          if (dependency) {
            if (properties2 !== void 0) {
              dependency[STR_PROPERTIES] = __assignFn(__assignFn({}, dependency.properties), properties2);
            }
            var sysProperties = ajaxData[_DYN_GET_PART_APROPS]();
            _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE2], ajaxData, dependency, null, sysProperties);
          } else {
            _reportFetchError(14, null, {
              requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME],
              responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI15]
            });
          }
        }, function(e) {
          _reportFetchError(18, e, null);
        });
      }
      function _getFetchCorrelationContext(response) {
        if (response && response[_DYN_HEADERS]) {
          try {
            var responseHeader = response[_DYN_HEADERS].get(RequestHeaders[0]);
            return CorrelationIdHelper[_DYN_GET_CORRELATION_CONT17](responseHeader);
          } catch (e) {
            _throwInternalWarning(_self, 18, CORRELATION_HEADER_ERROR, {
              fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
              exception: dumpObj(e)
            });
          }
        }
      }
      function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
        var _a2;
        var result = true;
        var initializersCount = initializers[_DYN_LENGTH3];
        if (initializersCount > 0) {
          var details = (_a2 = {
            item: dependency
          }, _a2[STR_PROPERTIES] = properties, _a2.sysProperties = systemProperties, _a2.context = ajaxData ? ajaxData[_DYN_CONTEXT] : null, _a2);
          result = _processDependencyContainer(core, initializers, details, "initializer");
        }
        if (result) {
          _self[_DYN_TRACK_DEPENDENCY_DAT4](dependency, properties, systemProperties);
        }
      }
    });
    return _this;
  }
  AjaxMonitor2.prototype.processTelemetry = function(item, itemCtx) {
    this.processNext(item, itemCtx);
  };
  AjaxMonitor2.prototype.addDependencyInitializer = function(dependencyInitializer) {
    return null;
  };
  AjaxMonitor2.identifier = "AjaxDependencyPlugin";
  AjaxMonitor2.getDefaultConfig = _getDefaultConfig2;
  AjaxMonitor2.getEmptyConfig = _getEmptyConfig;
  return AjaxMonitor2;
}(BaseTelemetryPlugin);

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Application.js
var Application = function() {
  function Application2() {
  }
  return Application2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Device.js
var Device = function() {
  function Device2() {
    this.id = "browser";
    this.deviceClass = "Browser";
  }
  return Device2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/__DynamicConstants.js
var _DYN_SESSION_MANAGER = "sessionManager";
var _DYN_UPDATE = "update";
var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet";
var _DYN_IS_NEW_USER = "isNewUser";
var _DYN_GET_TRACE_CTX = "getTraceCtx";
var _DYN_TELEMETRY_TRACE = "telemetryTrace";
var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext";
var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext";
var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext";
var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext";
var _DYN_APPLY_USER_CONTEXT = "applyUserContext";
var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt";
var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext";
var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext";
var _DYN_ACCOUNT_ID = "accountId";
var _DYN_SDK_EXTENSION = "sdkExtension";
var _DYN_GET_SESSION_ID = "getSessionId";
var _DYN_NAME_PREFIX3 = "namePrefix";
var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix";
var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix";
var _DYN_ID_LENGTH = "idLength";
var _DYN_GET_NEW_ID = "getNewId";
var _DYN_LENGTH4 = "length";
var _DYN_AUTOMATIC_SESSION = "automaticSession";
var _DYN_AUTHENTICATED_ID = "authenticatedId";
var _DYN_SESSION_EXPIRATION_M7 = "sessionExpirationMs";
var _DYN_SESSION_RENEWAL_MS = "sessionRenewalMs";
var _DYN_CONFIG = "config";
var _DYN_ACQUISITION_DATE = "acquisitionDate";
var _DYN_RENEWAL_DATE = "renewalDate";
var _DYN_COOKIE_DOMAIN = "cookieDomain";
var _DYN_JOIN = "join";
var _DYN_COOKIE_SEPARATOR = "cookieSeparator";
var _DYN_AUTH_USER_COOKIE_NAM8 = "authUserCookieName";

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Internal.js
var Version = "2.8.8";
var Internal = function() {
  function Internal2(config) {
    this.sdkVersion = (config[_DYN_SDK_EXTENSION] && config[_DYN_SDK_EXTENSION]() ? config[_DYN_SDK_EXTENSION]() + "_" : "") + "javascript:" + Version;
  }
  return Internal2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Location.js
var Location = function() {
  function Location2() {
  }
  return Location2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Session.js
var cookieNameConst = "ai_session";
var Session = function() {
  function Session2() {
  }
  return Session2;
}();
var _SessionManager = function() {
  function _SessionManager2(config, core) {
    var self = this;
    var _storageNamePrefix;
    var _cookieUpdatedTimestamp;
    var _logger = safeGetLogger(core);
    var _cookieManager = safeGetCookieMgr(core);
    dynamicProto(_SessionManager2, self, function(_self) {
      if (!config) {
        config = {};
      }
      if (!isFunction(config[_DYN_SESSION_EXPIRATION_M7])) {
        config[_DYN_SESSION_EXPIRATION_M7] = function() {
          return _SessionManager2.acquisitionSpan;
        };
      }
      if (!isFunction(config[_DYN_SESSION_RENEWAL_MS])) {
        config[_DYN_SESSION_RENEWAL_MS] = function() {
          return _SessionManager2.renewalSpan;
        };
      }
      _self[_DYN_CONFIG] = config;
      var sessionCookiePostfix = _self.config[_DYN_SESSION_COOKIE_POSTF6] && _self[_DYN_CONFIG][_DYN_SESSION_COOKIE_POSTF6]() ? _self.config[_DYN_SESSION_COOKIE_POSTF6]() : _self.config[_DYN_NAME_PREFIX3] && _self[_DYN_CONFIG][_DYN_NAME_PREFIX3]() ? _self[_DYN_CONFIG][_DYN_NAME_PREFIX3]() : "";
      _storageNamePrefix = function() {
        return cookieNameConst + sessionCookiePostfix;
      };
      _self[_DYN_AUTOMATIC_SESSION] = new Session();
      _self[_DYN_UPDATE] = function() {
        var nowMs = dateNow();
        var isExpired = false;
        var session = _self[_DYN_AUTOMATIC_SESSION];
        if (!session.id) {
          isExpired = !_initializeAutomaticSession(session, nowMs);
        }
        var sessionExpirationMs = _self.config[_DYN_SESSION_EXPIRATION_M7]();
        if (!isExpired && sessionExpirationMs > 0) {
          var sessionRenewalMs = _self.config[_DYN_SESSION_RENEWAL_MS]();
          var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE];
          var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE];
          isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0;
          isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs;
          isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs;
        }
        if (isExpired) {
          _renew(nowMs);
        } else {
          if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager2.cookieUpdateInterval) {
            _setCookie(session, nowMs);
          }
        }
      };
      _self.backup = function() {
        var session = _self[_DYN_AUTOMATIC_SESSION];
        _setStorage(session.id, session[_DYN_ACQUISITION_DATE], session[_DYN_RENEWAL_DATE]);
      };
      function _initializeAutomaticSession(session, now) {
        var isValid = false;
        var cookieValue = _cookieManager.get(_storageNamePrefix());
        if (cookieValue && isFunction(cookieValue.split)) {
          isValid = _initializeAutomaticSessionWithData(session, cookieValue);
        } else {
          var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix());
          if (storageValue) {
            isValid = _initializeAutomaticSessionWithData(session, storageValue);
          }
        }
        return isValid || !!session.id;
      }
      function _initializeAutomaticSessionWithData(session, sessionData) {
        var isValid = false;
        var sessionReset = ", session will be reset";
        var tokens = sessionData.split("|");
        if (tokens[_DYN_LENGTH4] >= 2) {
          try {
            var acqMs = +tokens[1] || 0;
            var renewalMs = +tokens[2] || 0;
            if (isNaN(acqMs) || acqMs <= 0) {
              _throwInternal(_logger, 2, 27, "AI session acquisition date is 0" + sessionReset);
            } else if (isNaN(renewalMs) || renewalMs <= 0) {
              _throwInternal(_logger, 2, 27, "AI session renewal date is 0" + sessionReset);
            } else if (tokens[0]) {
              session.id = tokens[0];
              session[_DYN_ACQUISITION_DATE] = acqMs;
              session[_DYN_RENEWAL_DATE] = renewalMs;
              isValid = true;
            }
          } catch (e) {
            _throwInternal(_logger, 1, 9, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), { exception: dumpObj(e) });
          }
        }
        return isValid;
      }
      function _renew(nowMs) {
        var theConfig = _self[_DYN_CONFIG] || {};
        var getNewId = (theConfig[_DYN_GET_NEW_ID] ? theConfig[_DYN_GET_NEW_ID]() : null) || newId;
        _self.automaticSession.id = getNewId(theConfig[_DYN_ID_LENGTH] ? theConfig[_DYN_ID_LENGTH]() : 22);
        _self[_DYN_AUTOMATIC_SESSION][_DYN_ACQUISITION_DATE] = nowMs;
        _setCookie(_self[_DYN_AUTOMATIC_SESSION], nowMs);
        if (!utlCanUseLocalStorage()) {
          _throwInternal(_logger, 2, 0, "Browser does not support local storage. Session durations will be inaccurate.");
        }
      }
      function _setCookie(session, nowMs) {
        var acq = session[_DYN_ACQUISITION_DATE];
        session[_DYN_RENEWAL_DATE] = nowMs;
        var config2 = _self[_DYN_CONFIG];
        var renewalPeriodMs = config2[_DYN_SESSION_RENEWAL_MS]();
        var acqTimeLeftMs = acq + config2[_DYN_SESSION_EXPIRATION_M7]() - nowMs;
        var cookie = [session.id, acq, nowMs];
        var maxAgeSec = 0;
        if (acqTimeLeftMs < renewalPeriodMs) {
          maxAgeSec = acqTimeLeftMs / 1e3;
        } else {
          maxAgeSec = renewalPeriodMs / 1e3;
        }
        var cookieDomain = config2[_DYN_COOKIE_DOMAIN] ? config2[_DYN_COOKIE_DOMAIN]() : null;
        _cookieManager.set(_storageNamePrefix(), cookie.join("|"), config2[_DYN_SESSION_EXPIRATION_M7]() > 0 ? maxAgeSec : null, cookieDomain);
        _cookieUpdatedTimestamp = nowMs;
      }
      function _setStorage(guid, acq, renewal) {
        utlSetLocalStorage(_logger, _storageNamePrefix(), [guid, acq, renewal][_DYN_JOIN]("|"));
      }
    });
  }
  _SessionManager2.acquisitionSpan = 864e5;
  _SessionManager2.renewalSpan = 18e5;
  _SessionManager2.cookieUpdateInterval = 6e4;
  return _SessionManager2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/TelemetryTrace.js
var TelemetryTrace = function() {
  function TelemetryTrace2(id, parentId, name, logger) {
    var _self = this;
    _self.traceID = id || generateW3CId();
    _self.parentID = parentId;
    var location = getLocation();
    if (!name && location && location.pathname) {
      name = location.pathname;
    }
    _self.name = dataSanitizeString(logger, name);
  }
  return TelemetryTrace2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/User.js
function _validateUserInput(id) {
  if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) {
    return false;
  }
  return true;
}
var User = function() {
  function User2(config, core) {
    this.isNewUser = false;
    this.isUserCookieSet = false;
    var _logger = safeGetLogger(core);
    var _cookieManager = safeGetCookieMgr(core);
    var _storageNamePrefix;
    dynamicProto(User2, this, function(_self) {
      _self[_DYN_CONFIG] = config;
      var userCookiePostfix = _self.config[_DYN_USER_COOKIE_POSTFIX] && _self[_DYN_CONFIG][_DYN_USER_COOKIE_POSTFIX]() ? _self[_DYN_CONFIG][_DYN_USER_COOKIE_POSTFIX]() : "";
      _storageNamePrefix = function() {
        return User2.userCookieName + userCookiePostfix;
      };
      var cookie = _cookieManager.get(_storageNamePrefix());
      if (cookie) {
        _self[_DYN_IS_NEW_USER] = false;
        var params = cookie.split(User2[_DYN_COOKIE_SEPARATOR]);
        if (params[_DYN_LENGTH4] > 0) {
          _self.id = params[0];
          _self[_DYN_IS_USER_COOKIE_SET] = !!_self.id;
        }
      }
      function _generateNewId() {
        var theConfig = config || {};
        var getNewId = (theConfig[_DYN_GET_NEW_ID] ? theConfig[_DYN_GET_NEW_ID]() : null) || newId;
        var id = getNewId(theConfig[_DYN_ID_LENGTH] ? config[_DYN_ID_LENGTH]() : 22);
        return id;
      }
      function _generateNewCookie(userId) {
        var acqStr = toISOString(new Date());
        _self.accountAcquisitionDate = acqStr;
        _self[_DYN_IS_NEW_USER] = true;
        var newCookie2 = [userId, acqStr];
        return newCookie2;
      }
      function _setUserCookie(cookie2) {
        var oneYear = 31536e3;
        _self[_DYN_IS_USER_COOKIE_SET] = _cookieManager.set(_storageNamePrefix(), cookie2, oneYear);
      }
      if (!_self.id) {
        _self.id = _generateNewId();
        var newCookie = _generateNewCookie(_self.id);
        _setUserCookie(newCookie[_DYN_JOIN](User2[_DYN_COOKIE_SEPARATOR]));
        var name_1 = config[_DYN_NAME_PREFIX3] && config[_DYN_NAME_PREFIX3]() ? config[_DYN_NAME_PREFIX3]() + "ai_session" : "ai_session";
        utlRemoveStorage(_logger, name_1);
      }
      _self[_DYN_ACCOUNT_ID] = config[_DYN_ACCOUNT_ID] ? config[_DYN_ACCOUNT_ID]() : void 0;
      var authCookie = _cookieManager.get(User2[_DYN_AUTH_USER_COOKIE_NAM8]);
      if (authCookie) {
        authCookie = decodeURI(authCookie);
        var authCookieString = authCookie.split(User2[_DYN_COOKIE_SEPARATOR]);
        if (authCookieString[0]) {
          _self[_DYN_AUTHENTICATED_ID] = authCookieString[0];
        }
        if (authCookieString[_DYN_LENGTH4] > 1 && authCookieString[1]) {
          _self[_DYN_ACCOUNT_ID] = authCookieString[1];
        }
      }
      _self.setAuthenticatedUserContext = function(authenticatedUserId, accountId, storeInCookie) {
        if (storeInCookie === void 0) {
          storeInCookie = false;
        }
        var isInvalidInput = !_validateUserInput(authenticatedUserId) || accountId && !_validateUserInput(accountId);
        if (isInvalidInput) {
          _throwInternal(_logger, 2, 60, "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
          return;
        }
        _self[_DYN_AUTHENTICATED_ID] = authenticatedUserId;
        var authCookie2 = _self[_DYN_AUTHENTICATED_ID];
        if (accountId) {
          _self[_DYN_ACCOUNT_ID] = accountId;
          authCookie2 = [_self[_DYN_AUTHENTICATED_ID], _self.accountId][_DYN_JOIN](User2[_DYN_COOKIE_SEPARATOR]);
        }
        if (storeInCookie) {
          _cookieManager.set(User2[_DYN_AUTH_USER_COOKIE_NAM8], encodeURI(authCookie2));
        }
      };
      _self.clearAuthenticatedUserContext = function() {
        _self[_DYN_AUTHENTICATED_ID] = null;
        _self[_DYN_ACCOUNT_ID] = null;
        _cookieManager.del(User2[_DYN_AUTH_USER_COOKIE_NAM8]);
      };
      _self[_DYN_UPDATE] = function(userId) {
        if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET]) {
          var user_id = userId ? userId : _generateNewId();
          var user_cookie = _generateNewCookie(user_id);
          _setUserCookie(user_cookie[_DYN_JOIN](User2[_DYN_COOKIE_SEPARATOR]));
        }
      };
    });
  }
  User2.cookieSeparator = "|";
  User2.userCookieName = "ai_user";
  User2.authUserCookieName = "ai_authUser";
  return User2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/TelemetryContext.js
var strExt = "ext";
var strTags = "tags";
function _removeEmpty(target, name) {
  if (target && target[name] && objKeys(target[name])[_DYN_LENGTH4] === 0) {
    delete target[name];
  }
}
var TelemetryContext = function() {
  function TelemetryContext2(core, defaultConfig, previousTraceCtx) {
    var _this = this;
    var logger = core.logger;
    this.appId = function() {
      return null;
    };
    this[_DYN_GET_SESSION_ID] = function() {
      return null;
    };
    dynamicProto(TelemetryContext2, this, function(_self) {
      _self.application = new Application();
      _self.internal = new Internal(defaultConfig);
      if (hasWindow()) {
        _self[_DYN_SESSION_MANAGER] = new _SessionManager(defaultConfig, core);
        _self.device = new Device();
        _self.location = new Location();
        _self.user = new User(defaultConfig, core);
        var traceId = void 0;
        var parentId = void 0;
        var name_1;
        if (previousTraceCtx) {
          traceId = previousTraceCtx.getTraceId();
          parentId = previousTraceCtx.getSpanId();
          name_1 = previousTraceCtx.getName();
        }
        _self[_DYN_TELEMETRY_TRACE] = new TelemetryTrace(traceId, parentId, name_1, logger);
        _self.session = new Session();
      }
      _self[_DYN_GET_SESSION_ID] = function() {
        var session = _self.session;
        var sesId = null;
        if (session && isString(session.id)) {
          sesId = session.id;
        } else {
          var autoSession = (_self[_DYN_SESSION_MANAGER] || {})[_DYN_AUTOMATIC_SESSION];
          sesId = autoSession && isString(autoSession.id) ? autoSession.id : null;
        }
        return sesId;
      };
      _self[_DYN_APPLY_SESSION_CONTEX0] = function(evt, itemCtx) {
        setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID](), isString);
      };
      _self[_DYN_APPLY_OPERATING_SYST3] = function(evt, itemCtx) {
        setValue(evt.ext, Extensions.OSExt, _self.os);
      };
      _self[_DYN_APPLY_APPLICATION_CO1] = function(evt, itemCtx) {
        var application = _self.application;
        if (application) {
          var tags = getSetValue(evt, strTags);
          setValue(tags, CtxTagKeys.applicationVersion, application.ver, isString);
          setValue(tags, CtxTagKeys.applicationBuild, application.build, isString);
        }
      };
      _self[_DYN_APPLY_DEVICE_CONTEXT] = function(evt, itemCtx) {
        var device = _self.device;
        if (device) {
          var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
          setValue(extDevice, "localId", device.id, isString);
          setValue(extDevice, "ip", device.ip, isString);
          setValue(extDevice, "model", device.model, isString);
          setValue(extDevice, "deviceClass", device.deviceClass, isString);
        }
      };
      _self[_DYN_APPLY_INTERNAL_CONTE5] = function(evt, itemCtx) {
        var internal = _self.internal;
        if (internal) {
          var tags = getSetValue(evt, strTags);
          setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, isString);
          setValue(tags, CtxTagKeys.internalSdkVersion, internal.sdkVersion, isString);
          if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageView.dataType) {
            setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, isString);
            setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, isString);
          }
        }
      };
      _self[_DYN_APPLY_LOCATION_CONTE4] = function(evt, itemCtx) {
        var location = _this.location;
        if (location) {
          setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, isString);
        }
      };
      _self[_DYN_APPLY_OPERATION_CONT2] = function(evt, itemCtx) {
        var telemetryTrace = _self[_DYN_TELEMETRY_TRACE];
        if (telemetryTrace) {
          var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, { traceID: void 0, parentID: void 0 });
          setValue(extTrace, "traceID", telemetryTrace.traceID, isString, isNullOrUndefined);
          setValue(extTrace, "name", telemetryTrace.name, isString, isNullOrUndefined);
          setValue(extTrace, "parentID", telemetryTrace.parentID, isString, isNullOrUndefined);
        }
      };
      _self.applyWebContext = function(evt, itemCtx) {
        var web = _this.web;
        if (web) {
          setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
        }
      };
      _self[_DYN_APPLY_USER_CONTEXT] = function(evt, itemCtx) {
        var user = _self.user;
        if (user) {
          var tags = getSetValue(evt, strTags, []);
          setValue(tags, CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID], isString);
          var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
          setValue(extUser, "id", user.id, isString);
          setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID], isString);
        }
      };
      _self.cleanUp = function(evt, itemCtx) {
        var ext = evt.ext;
        if (ext) {
          _removeEmpty(ext, Extensions.DeviceExt);
          _removeEmpty(ext, Extensions.UserExt);
          _removeEmpty(ext, Extensions.WebExt);
          _removeEmpty(ext, Extensions.OSExt);
          _removeEmpty(ext, Extensions.AppExt);
          _removeEmpty(ext, Extensions.TraceExt);
        }
      };
    });
  }
  TelemetryContext2.__ieDyn = 1;
  return TelemetryContext2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-properties-js@2.8.8/node_modules/@microsoft/applicationinsights-properties-js/dist-esm/PropertiesPlugin.js
var PropertiesPlugin = function(_super) {
  __extendsFn(PropertiesPlugin2, _super);
  function PropertiesPlugin2() {
    var _this = _super.call(this) || this;
    _this.priority = 110;
    _this.identifier = PropertiesPluginIdentifier;
    var _extensionConfig;
    var _distributedTraceCtx;
    var _previousTraceCtx;
    dynamicProto(PropertiesPlugin2, _this, function(_self, _base) {
      _initDefaults();
      _self.initialize = function(config, core, extensions, pluginChain) {
        _base.initialize(config, core, extensions, pluginChain);
        _populateDefaults(config);
      };
      _self.processTelemetry = function(event, itemCtx) {
        if (isNullOrUndefined(event)) {
        } else {
          itemCtx = _self._getTelCtx(itemCtx);
          if (event.name === PageView.envelopeType) {
            itemCtx.diagLog().resetInternalMessageCount();
          }
          var theContext = _self.context || {};
          if (theContext.session) {
            if (typeof _self.context.session.id !== "string" && theContext[_DYN_SESSION_MANAGER]) {
              theContext[_DYN_SESSION_MANAGER][_DYN_UPDATE]();
            }
          }
          var userCtx = theContext.user;
          if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET]) {
            userCtx[_DYN_UPDATE](theContext.user.id);
          }
          _processTelemetryInternal(event, itemCtx);
          if (userCtx && userCtx[_DYN_IS_NEW_USER]) {
            userCtx[_DYN_IS_NEW_USER] = false;
            var message = new _InternalLogMessage(72, (getNavigator() || {}).userAgent || "");
            _logInternalMessage(itemCtx.diagLog(), 1, message);
          }
          _self.processNext(event, itemCtx);
        }
      };
      _self._doTeardown = function(unloadCtx, unloadState) {
        var core = (unloadCtx || {}).core();
        if (core && core[_DYN_GET_TRACE_CTX]) {
          var traceCtx = core[_DYN_GET_TRACE_CTX](false);
          if (traceCtx === _distributedTraceCtx) {
            core.setTraceCtx(_previousTraceCtx);
          }
        }
        _initDefaults();
      };
      function _initDefaults() {
        _extensionConfig = null;
        _distributedTraceCtx = null;
        _previousTraceCtx = null;
      }
      function _populateDefaults(config) {
        var identifier = _self.identifier;
        var core = _self.core;
        var ctx = createProcessTelemetryContext(null, config, core);
        var defaultConfig = PropertiesPlugin2.getDefaultConfig();
        _extensionConfig = _extensionConfig || {};
        objForEachKey(defaultConfig, function(field, value) {
          _extensionConfig[field] = function() {
            return ctx.getConfig(identifier, field, value());
          };
        });
        _previousTraceCtx = core[_DYN_GET_TRACE_CTX](false);
        _self.context = new TelemetryContext(core, _extensionConfig, _previousTraceCtx);
        _distributedTraceCtx = createDistributedTraceContextFromTrace(_self.context[_DYN_TELEMETRY_TRACE], _previousTraceCtx);
        core.setTraceCtx(_distributedTraceCtx);
        _self.context.appId = function() {
          var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
          return breezeChannel ? breezeChannel.plugin["_appId"] : null;
        };
        _self["_extConfig"] = _extensionConfig;
      }
      function _processTelemetryInternal(evt, itemCtx) {
        getSetValue(evt, "tags", []);
        getSetValue(evt, "ext", {});
        var ctx = _self.context;
        ctx[_DYN_APPLY_SESSION_CONTEX0](evt, itemCtx);
        ctx[_DYN_APPLY_APPLICATION_CO1](evt, itemCtx);
        ctx[_DYN_APPLY_DEVICE_CONTEXT](evt, itemCtx);
        ctx[_DYN_APPLY_OPERATION_CONT2](evt, itemCtx);
        ctx[_DYN_APPLY_USER_CONTEXT](evt, itemCtx);
        ctx[_DYN_APPLY_OPERATING_SYST3](evt, itemCtx);
        ctx.applyWebContext(evt, itemCtx);
        ctx[_DYN_APPLY_LOCATION_CONTE4](evt, itemCtx);
        ctx[_DYN_APPLY_INTERNAL_CONTE5](evt, itemCtx);
        ctx.cleanUp(evt, itemCtx);
      }
    });
    return _this;
  }
  PropertiesPlugin2.getDefaultConfig = function() {
    var _a2;
    var defaultValue;
    var nullValue = null;
    var defaultConfig = (_a2 = {
      instrumentationKey: function() {
        return defaultValue;
      }
    }, _a2[_DYN_ACCOUNT_ID] = function() {
      return nullValue;
    }, _a2.sessionRenewalMs = function() {
      return 30 * 60 * 1e3;
    }, _a2.samplingPercentage = function() {
      return 100;
    }, _a2.sessionExpirationMs = function() {
      return 24 * 60 * 60 * 1e3;
    }, _a2[_DYN_COOKIE_DOMAIN] = function() {
      return nullValue;
    }, _a2[_DYN_SDK_EXTENSION] = function() {
      return nullValue;
    }, _a2.isBrowserLinkTrackingEnabled = function() {
      return false;
    }, _a2.appId = function() {
      return nullValue;
    }, _a2[_DYN_GET_SESSION_ID] = function() {
      return nullValue;
    }, _a2[_DYN_NAME_PREFIX3] = function() {
      return defaultValue;
    }, _a2[_DYN_SESSION_COOKIE_POSTF6] = function() {
      return defaultValue;
    }, _a2[_DYN_USER_COOKIE_POSTFIX] = function() {
      return defaultValue;
    }, _a2[_DYN_ID_LENGTH] = function() {
      return 22;
    }, _a2[_DYN_GET_NEW_ID] = function() {
      return nullValue;
    }, _a2);
    return defaultConfig;
  };
  return PropertiesPlugin2;
}(BaseTelemetryPlugin);
var PropertiesPlugin_default = PropertiesPlugin;

// node_modules/.pnpm/@microsoft+applicationinsights-web@2.8.8/node_modules/@microsoft/applicationinsights-web/dist-esm/InternalConstants.js
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
var STR_SNIPPET = "snippet";
var STR_GET_COOKIE_MGR = "getCookieMgr";
var STR_START_TRACK_PAGE = "startTrackPage";
var STR_STOP_TRACK_PAGE = "stopTrackPage";
var STR_FLUSH = "flush";
var STR_START_TRACK_EVENT = "startTrackEvent";
var STR_STOP_TRACK_EVENT = "stopTrackEvent";
var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
var STR_ADD_TELEMETRY_INITIALIZERS = STR_ADD_TELEMETRY_INITIALIZER + "s";
var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
var STR_GET_PLUGIN = "getPlugin";
var STR_EVT_NAMESPACE = "evtNamespace";
var STR_TRACK_EVENT = _TRACK + "Event";
var STR_TRACK_TRACE = _TRACK + "Trace";
var STR_TRACK_METRIC = _TRACK + "Metric";
var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
var STR_TRACK_EXCEPTION = _TRACK + "Exception";
var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;

// node_modules/.pnpm/@microsoft+applicationinsights-web@2.8.8/node_modules/@microsoft/applicationinsights-web/dist-esm/__DynamicConstants.js
var _DYN_UPDATE_SNIPPET_DEFIN0 = "updateSnippetDefinitions";
var _DYN_LOAD_APP_INSIGHTS = "loadAppInsights";
var _DYN_ENDPOINT_URL2 = "endpointUrl";
var _DYN_MAX_BATCH_SIZE_IN_BY12 = "maxBatchSizeInBytes";
var _DYN_MAX_BATCH_INTERVAL2 = "maxBatchInterval";
var _DYN_DISABLE_EXCEPTION_TR2 = "disableExceptionTracking";
var _DYN_DISABLE_TELEMETRY2 = "disableTelemetry";
var _DYN_EMIT_LINE_DELIMITED_3 = "emitLineDelimitedJson";
var _DYN_DIAGNOSTIC_LOG_INTER4 = "diagnosticLogInterval";
var _DYN_AUTO_TRACK_PAGE_VISI5 = "autoTrackPageVisitTime";
var _DYN_SAMPLING_PERCENTAGE3 = "samplingPercentage";
var _DYN_DISABLE_AJAX_TRACKIN6 = "disableAjaxTracking";
var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView";
var _DYN_IS_BEACON_API_DISABL8 = "isBeaconApiDisabled";
var _DYN_DISABLE_CORRELATION_9 = "disableCorrelationHeaders";
var _DYN_CORRELATION_HEADER_E10 = "correlationHeaderExcludedDomains";
var _DYN_DISABLE_FLUSH_ON_BEF11 = "disableFlushOnBeforeUnload";
var _DYN_DISABLE_FLUSH_ON_UNL12 = "disableFlushOnUnload";
var _DYN_ENABLE_SESSION_STORA13 = "enableSessionStorageBuffer";
var _DYN_IS_COOKIE_USE_DISABL14 = "isCookieUseDisabled";
var _DYN_IS_STORAGE_USE_DISAB15 = "isStorageUseDisabled";
var _DYN_IS_BROWSER_LINK_TRAC16 = "isBrowserLinkTrackingEnabled";
var _DYN_ENABLE_CORS_CORRELAT17 = "enableCorsCorrelation";
var _DYN_CONFIG2 = "config";
var _DYN_CONTEXT2 = "context";
var _DYN_PUSH2 = "push";
var _DYN_VERSION = "version";
var _DYN_QUEUE = "queue";
var _DYN_CONNECTION_STRING = "connectionString";
var _DYN_INSTRUMENTATION_KEY2 = "instrumentationKey";
var _DYN_APP_INSIGHTS = "appInsights";
var _DYN_DISABLE_IKEY_DEPRECA18 = "disableIkeyDeprecationMessage";
var _DYN_GET_TRANSMISSION_CON19 = "getTransmissionControls";
var _DYN_ONUNLOAD_FLUSH = "onunloadFlush";
var _DYN_ADD_HOUSEKEEPING_BEF20 = "addHousekeepingBeforeUnload";
var _DYN_INDEX_OF = "indexOf";

// node_modules/.pnpm/@microsoft+applicationinsights-web@2.8.8/node_modules/@microsoft/applicationinsights-web/dist-esm/Initialization.js
var _internalSdkSrc;
var _ignoreUpdateSnippetProperties = [
  STR_SNIPPET,
  "dependencies",
  "properties",
  "_snippetVersion",
  "appInsightsNew",
  "getSKUDefaults"
];
var fieldType = {
  Default: 0,
  Required: 1,
  Array: 2,
  Hidden: 4
};
var Telemetry = {
  __proto__: null,
  PropertiesPluginIdentifier,
  BreezeChannelIdentifier,
  AnalyticsPluginIdentifier,
  Util,
  CorrelationIdHelper,
  UrlHelper,
  DateTimeUtils,
  ConnectionStringParser,
  FieldType: fieldType,
  RequestHeaders,
  DisabledPropertyName,
  ProcessLegacy,
  SampleRate,
  HttpMethod,
  DEFAULT_BREEZE_ENDPOINT,
  Envelope,
  Event: Event2,
  Exception,
  Metric,
  PageView,
  RemoteDependencyData,
  Trace,
  PageViewPerformance,
  Data,
  SeverityLevel,
  ConfigurationManager,
  ContextTagKeys,
  DataSanitizer,
  TelemetryItemCreator,
  CtxTagKeys,
  Extensions,
  DistributedTracingModes
};
var Initialization = function() {
  function Initialization2(snippet) {
    var _this = this;
    var dependencies;
    var properties;
    var _sender;
    var _snippetVersion;
    var _evtNamespace;
    var _houseKeepingNamespace;
    var _core;
    dynamicProto(Initialization2, this, function(_self) {
      _initDefaults();
      _snippetVersion = "" + (snippet.sv || snippet[_DYN_VERSION] || "");
      snippet[_DYN_QUEUE] = snippet[_DYN_QUEUE] || [];
      snippet[_DYN_VERSION] = snippet[_DYN_VERSION] || 2;
      var config = snippet[_DYN_CONFIG2] || {};
      if (config[_DYN_CONNECTION_STRING]) {
        var cs = parseConnectionString(config[_DYN_CONNECTION_STRING]);
        var ingest = cs.ingestionendpoint;
        config[_DYN_ENDPOINT_URL2] = ingest ? ingest + DEFAULT_BREEZE_PATH : config[_DYN_ENDPOINT_URL2];
        config[_DYN_INSTRUMENTATION_KEY2] = cs.instrumentationkey || config[_DYN_INSTRUMENTATION_KEY2];
      }
      _self[_DYN_APP_INSIGHTS] = new AnalyticsPlugin();
      properties = new PropertiesPlugin_default();
      dependencies = new AjaxMonitor();
      _sender = new Sender();
      _core = new AppInsightsCore();
      _self.core = _core;
      var isErrMessageDisabled = isNullOrUndefined(config[_DYN_DISABLE_IKEY_DEPRECA18]) ? true : config[_DYN_DISABLE_IKEY_DEPRECA18];
      if (!config[_DYN_CONNECTION_STRING] && !isErrMessageDisabled) {
        _throwInternal(_core.logger, 1, 106, "Instrumentation key support will end soon, see aka.ms/IkeyMigrate");
      }
      _self[STR_SNIPPET] = snippet;
      _self[_DYN_CONFIG2] = config;
      _getSKUDefaults();
      _self[STR_FLUSH] = function(async) {
        if (async === void 0) {
          async = true;
        }
        doPerf(_core, function() {
          return "AISKU.flush";
        }, function() {
          arrForEach(_core[_DYN_GET_TRANSMISSION_CON19](), function(channels) {
            arrForEach(channels, function(channel) {
              channel[STR_FLUSH](async);
            });
          });
        }, null, async);
      };
      _self[_DYN_ONUNLOAD_FLUSH] = function(async) {
        if (async === void 0) {
          async = true;
        }
        arrForEach(_core[_DYN_GET_TRANSMISSION_CON19](), function(channels) {
          arrForEach(channels, function(channel) {
            if (channel[_DYN_ONUNLOAD_FLUSH]) {
              channel[_DYN_ONUNLOAD_FLUSH]();
            } else {
              channel[STR_FLUSH](async);
            }
          });
        });
      };
      _self[_DYN_LOAD_APP_INSIGHTS] = function(legacyMode, logger, notificationManager) {
        if (legacyMode === void 0) {
          legacyMode = false;
        }
        function _updateSnippetProperties(snippet2) {
          if (snippet2) {
            var snippetVer = "";
            if (!isNullOrUndefined(_snippetVersion)) {
              snippetVer += _snippetVersion;
            }
            if (legacyMode) {
              snippetVer += ".lg";
            }
            if (_self[_DYN_CONTEXT2] && _self[_DYN_CONTEXT2].internal) {
              _self[_DYN_CONTEXT2].internal.snippetVer = snippetVer || "-";
            }
            objForEachKey(_self, function(field, value) {
              if (isString(field) && !isFunction(value) && field && field[0] !== "_" && arrIndexOf(_ignoreUpdateSnippetProperties, field) === -1) {
                snippet2[field] = value;
              }
            });
          }
        }
        if (legacyMode && _self[_DYN_CONFIG2].extensions && _self[_DYN_CONFIG2].extensions.length > 0) {
          throwError("Extensions not allowed in legacy mode");
        }
        doPerf(_self.core, function() {
          return "AISKU.loadAppInsights";
        }, function() {
          var extensions = [];
          extensions[_DYN_PUSH2](_sender);
          extensions[_DYN_PUSH2](properties);
          extensions[_DYN_PUSH2](dependencies);
          extensions[_DYN_PUSH2](_self[_DYN_APP_INSIGHTS]);
          _core.initialize(_self[_DYN_CONFIG2], extensions, logger, notificationManager);
          _self[_DYN_CONTEXT2] = properties[_DYN_CONTEXT2];
          if (_internalSdkSrc && _self[_DYN_CONTEXT2]) {
            _self[_DYN_CONTEXT2].internal.sdkSrc = _internalSdkSrc;
          }
          _updateSnippetProperties(_self[STR_SNIPPET]);
          _self.emptyQueue();
          _self[STR_POLL_INTERNAL_LOGS]();
          _self[_DYN_ADD_HOUSEKEEPING_BEF20](_this);
        });
        return _self;
      };
      _self[_DYN_UPDATE_SNIPPET_DEFIN0] = function(snippet2) {
        proxyAssign(snippet2, _self, function(name) {
          return name && arrIndexOf(_ignoreUpdateSnippetProperties, name) === -1;
        });
      };
      _self.emptyQueue = function() {
        try {
          if (isArray(_self.snippet[_DYN_QUEUE])) {
            var length_1 = _self.snippet[_DYN_QUEUE].length;
            for (var i = 0; i < length_1; i++) {
              var call = _self.snippet[_DYN_QUEUE][i];
              call();
            }
            _self.snippet[_DYN_QUEUE] = void 0;
            delete _self.snippet[_DYN_QUEUE];
          }
        } catch (exception) {
          var properties_1 = {};
          if (exception && isFunction(exception.toString)) {
            properties_1.exception = exception.toString();
          }
        }
      };
      _self[_DYN_ADD_HOUSEKEEPING_BEF20] = function(appInsightsInstance) {
        if (hasWindow() || hasDocument()) {
          var performHousekeeping = function() {
            appInsightsInstance[_DYN_ONUNLOAD_FLUSH](false);
            if (isFunction(_this.core[STR_GET_PLUGIN])) {
              var loadedPlugin = _this.core[STR_GET_PLUGIN](PropertiesPluginIdentifier);
              if (loadedPlugin) {
                var propertiesPlugin = loadedPlugin.plugin;
                if (propertiesPlugin && propertiesPlugin[_DYN_CONTEXT2] && propertiesPlugin[_DYN_CONTEXT2]._sessionManager) {
                  propertiesPlugin[_DYN_CONTEXT2]._sessionManager.backup();
                }
              }
            }
          };
          var added = false;
          var excludePageUnloadEvents = appInsightsInstance.appInsights[_DYN_CONFIG2].disablePageUnloadEvents;
          if (!_houseKeepingNamespace) {
            _houseKeepingNamespace = mergeEvtNamespace(_evtNamespace, _core[STR_EVT_NAMESPACE] && _core[STR_EVT_NAMESPACE]());
          }
          if (!appInsightsInstance.appInsights.config[_DYN_DISABLE_FLUSH_ON_BEF11]) {
            if (addPageUnloadEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
              added = true;
            }
            if (addPageHideEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
              added = true;
            }
            if (!added && !isReactNative()) {
              _throwInternal(appInsightsInstance[_DYN_APP_INSIGHTS].core.logger, 1, 19, "Could not add handler for beforeunload and pagehide");
            }
          }
          if (!added && !appInsightsInstance.appInsights.config[_DYN_DISABLE_FLUSH_ON_UNL12]) {
            addPageHideEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace);
          }
        }
      };
      _self.getSender = function() {
        return _sender;
      };
      _self.unload = function(isAsync, unloadComplete, cbTimeout) {
        _self[_DYN_ONUNLOAD_FLUSH](isAsync);
        if (_houseKeepingNamespace) {
          removePageUnloadEventListener(null, _houseKeepingNamespace);
          removePageHideEventListener(null, _houseKeepingNamespace);
        }
        _core.unload && _core.unload(isAsync, unloadComplete, cbTimeout);
      };
      proxyFunctions(_self, _self[_DYN_APP_INSIGHTS], [
        STR_GET_COOKIE_MGR,
        STR_TRACK_EVENT,
        STR_TRACK_PAGE_VIEW,
        "trackPageViewPerformance",
        STR_TRACK_EXCEPTION,
        "_onerror",
        STR_TRACK_TRACE,
        STR_TRACK_METRIC,
        STR_START_TRACK_PAGE,
        STR_STOP_TRACK_PAGE,
        STR_START_TRACK_EVENT,
        STR_STOP_TRACK_EVENT
      ]);
      proxyFunctions(_self, _getCurrentDependencies, [
        STR_TRACK_DEPENDENCY_DATA,
        "addDependencyListener",
        "addDependencyInitializer"
      ]);
      proxyFunctions(_self, _core, [
        STR_ADD_TELEMETRY_INITIALIZER,
        STR_POLL_INTERNAL_LOGS,
        "stopPollingInternalLogs",
        STR_GET_PLUGIN,
        "addPlugin",
        STR_EVT_NAMESPACE,
        "addUnloadCb",
        "getTraceCtx"
      ]);
      proxyFunctions(_self, function() {
        var context = properties[_DYN_CONTEXT2];
        return context ? context.user : null;
      }, [
        STR_SET_AUTHENTICATED_USER_CONTEXT,
        STR_CLEAR_AUTHENTICATED_USER_CONTEXT
      ]);
      function _getSKUDefaults() {
        _self.config[_DYN_DIAGNOSTIC_LOG_INTER4] = _self.config[_DYN_DIAGNOSTIC_LOG_INTER4] && _self[_DYN_CONFIG2][_DYN_DIAGNOSTIC_LOG_INTER4] > 0 ? _self[_DYN_CONFIG2][_DYN_DIAGNOSTIC_LOG_INTER4] : 1e4;
      }
      function _getCurrentDependencies() {
        return dependencies;
      }
      function _initDefaults() {
        _evtNamespace = createUniqueNamespace("AISKU");
        _houseKeepingNamespace = null;
        dependencies = null;
        properties = null;
        _sender = null;
        _snippetVersion = null;
      }
    });
  }
  Initialization2.prototype.addDependencyInitializer = function(dependencyInitializer) {
    return null;
  };
  return Initialization2;
}();
(function() {
  var sdkSrc = null;
  var isModule = false;
  var cdns = [
    "://js.monitor.azure.com/",
    "://az416426.vo.msecnd.net/"
  ];
  try {
    var scrpt = (document || {}).currentScript;
    if (scrpt) {
      sdkSrc = scrpt.src;
    }
  } catch (e) {
  }
  if (sdkSrc) {
    try {
      var url = sdkSrc.toLowerCase();
      if (url) {
        var src = "";
        for (var idx = 0; idx < cdns.length; idx++) {
          if (url[_DYN_INDEX_OF](cdns[idx]) !== -1) {
            src = "cdn" + (idx + 1);
            if (url[_DYN_INDEX_OF]("/scripts/") === -1) {
              if (url[_DYN_INDEX_OF]("/next/") !== -1) {
                src += "-next";
              } else if (url[_DYN_INDEX_OF]("/beta/") !== -1) {
                src += "-beta";
              }
            }
            _internalSdkSrc = src + (isModule ? ".mod" : "");
            break;
          }
        }
      }
    } catch (e) {
    }
  }
})();

// node_modules/.pnpm/@microsoft+applicationinsights-web@2.8.8/node_modules/@microsoft/applicationinsights-web/dist-esm/ApplicationInsightsDeprecated.js
var _ignoreUpdateSnippetProperties2 = [
  STR_SNIPPET,
  "getDefaultConfig",
  "_hasLegacyInitializers",
  "_queue",
  "_processLegacyInitializers"
];
function getDefaultConfig(config) {
  if (!config) {
    config = {};
  }
  config[_DYN_ENDPOINT_URL2] = config[_DYN_ENDPOINT_URL2] || DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH;
  config.sessionRenewalMs = 30 * 60 * 1e3;
  config.sessionExpirationMs = 24 * 60 * 60 * 1e3;
  config[_DYN_MAX_BATCH_SIZE_IN_BY12] = config[_DYN_MAX_BATCH_SIZE_IN_BY12] > 0 ? config[_DYN_MAX_BATCH_SIZE_IN_BY12] : 102400;
  config[_DYN_MAX_BATCH_INTERVAL2] = !isNaN(config[_DYN_MAX_BATCH_INTERVAL2]) ? config[_DYN_MAX_BATCH_INTERVAL2] : 15e3;
  config.enableDebug = stringToBoolOrDefault(config.enableDebug);
  config[_DYN_DISABLE_EXCEPTION_TR2] = stringToBoolOrDefault(config[_DYN_DISABLE_EXCEPTION_TR2]);
  config[_DYN_DISABLE_TELEMETRY2] = stringToBoolOrDefault(config[_DYN_DISABLE_TELEMETRY2]);
  config.verboseLogging = stringToBoolOrDefault(config.verboseLogging);
  config[_DYN_EMIT_LINE_DELIMITED_3] = stringToBoolOrDefault(config[_DYN_EMIT_LINE_DELIMITED_3]);
  config[_DYN_DIAGNOSTIC_LOG_INTER4] = config[_DYN_DIAGNOSTIC_LOG_INTER4] || 1e4;
  config[_DYN_AUTO_TRACK_PAGE_VISI5] = stringToBoolOrDefault(config[_DYN_AUTO_TRACK_PAGE_VISI5]);
  if (isNaN(config[_DYN_SAMPLING_PERCENTAGE3]) || config[_DYN_SAMPLING_PERCENTAGE3] <= 0 || config[_DYN_SAMPLING_PERCENTAGE3] >= 100) {
    config[_DYN_SAMPLING_PERCENTAGE3] = 100;
  }
  config[_DYN_DISABLE_AJAX_TRACKIN6] = stringToBoolOrDefault(config[_DYN_DISABLE_AJAX_TRACKIN6]);
  config[_DYN_MAX_AJAX_CALLS_PER_V7] = !isNaN(config[_DYN_MAX_AJAX_CALLS_PER_V7]) ? config[_DYN_MAX_AJAX_CALLS_PER_V7] : 500;
  config[_DYN_IS_BEACON_API_DISABL8] = stringToBoolOrDefault(config[_DYN_IS_BEACON_API_DISABL8], true);
  config[_DYN_DISABLE_CORRELATION_9] = stringToBoolOrDefault(config[_DYN_DISABLE_CORRELATION_9]);
  config[_DYN_CORRELATION_HEADER_E10] = config[_DYN_CORRELATION_HEADER_E10] || DfltAjaxCorrelationHeaderExDomains;
  config[_DYN_DISABLE_FLUSH_ON_BEF11] = stringToBoolOrDefault(config[_DYN_DISABLE_FLUSH_ON_BEF11]);
  config.disableFlushOnUnload = stringToBoolOrDefault(config.disableFlushOnUnload, config[_DYN_DISABLE_FLUSH_ON_BEF11]);
  config[_DYN_ENABLE_SESSION_STORA13] = stringToBoolOrDefault(config[_DYN_ENABLE_SESSION_STORA13], true);
  config.isRetryDisabled = stringToBoolOrDefault(config.isRetryDisabled);
  config[_DYN_IS_COOKIE_USE_DISABL14] = stringToBoolOrDefault(config[_DYN_IS_COOKIE_USE_DISABL14]);
  config[_DYN_IS_STORAGE_USE_DISAB15] = stringToBoolOrDefault(config[_DYN_IS_STORAGE_USE_DISAB15]);
  config[_DYN_IS_BROWSER_LINK_TRAC16] = stringToBoolOrDefault(config[_DYN_IS_BROWSER_LINK_TRAC16]);
  config[_DYN_ENABLE_CORS_CORRELAT17] = stringToBoolOrDefault(config[_DYN_ENABLE_CORS_CORRELAT17]);
  return config;
}
var AppInsightsDeprecated = function() {
  function AppInsightsDeprecated2(snippet, appInsightsNew) {
    var _this = this;
    var _hasLegacyInitializers = false;
    var _queue = [];
    var _config;
    dynamicProto(AppInsightsDeprecated2, this, function(_self) {
      _config = getDefaultConfig(snippet[_DYN_CONFIG2]);
      _self[_DYN_CONFIG2] = _config;
      _self[STR_SNIPPET] = snippet;
      _self.appInsightsNew = appInsightsNew;
      _self[_DYN_CONTEXT2] = { addTelemetryInitializer: _addTelemetryInitializers.bind(_self) };
      _self[STR_ADD_TELEMETRY_INITIALIZERS] = _addTelemetryInitializers;
      function _addTelemetryInitializers(callBack) {
        if (!_hasLegacyInitializers) {
          appInsightsNew[STR_ADD_TELEMETRY_INITIALIZER](function(item) {
            _processLegacyInitializers(item);
          });
          _hasLegacyInitializers = true;
        }
        _queue[_DYN_PUSH2](callBack);
      }
      proxyFunctions(_self, appInsightsNew, [
        STR_GET_COOKIE_MGR,
        STR_START_TRACK_PAGE,
        STR_STOP_TRACK_PAGE,
        STR_FLUSH,
        STR_START_TRACK_EVENT,
        STR_STOP_TRACK_EVENT
      ]);
      _self[STR_TRACK_PAGE_VIEW] = function(name, url, properties, measurements, duration) {
        var telemetry = {
          name,
          uri: url,
          properties,
          measurements
        };
        appInsightsNew[STR_TRACK_PAGE_VIEW](telemetry);
      };
      _self[STR_TRACK_EVENT] = function(name, properties, measurements) {
        appInsightsNew[STR_TRACK_EVENT]({ name });
      };
      _self.trackDependency = function(id, method, absoluteUrl, pathName, totalTime, success, resultCode) {
        appInsightsNew[STR_TRACK_DEPENDENCY_DATA]({
          id,
          target: absoluteUrl,
          type: pathName,
          duration: totalTime,
          properties: { HttpMethod: method },
          success,
          responseCode: resultCode
        });
      };
      _self[STR_TRACK_EXCEPTION] = function(exception, handledAt, properties, measurements, severityLevel) {
        appInsightsNew[STR_TRACK_EXCEPTION]({
          exception
        });
      };
      _self[STR_TRACK_METRIC] = function(name, average, sampleCount, min, max, properties) {
        appInsightsNew[STR_TRACK_METRIC]({ name, average, sampleCount, min, max });
      };
      _self[STR_TRACK_TRACE] = function(message, properties, severityLevel) {
        appInsightsNew[STR_TRACK_TRACE]({ message, severityLevel });
      };
      _self[STR_SET_AUTHENTICATED_USER_CONTEXT] = function(authenticatedUserId, accountId, storeInCookie) {
        appInsightsNew[_DYN_CONTEXT2].user[STR_SET_AUTHENTICATED_USER_CONTEXT](authenticatedUserId, accountId, storeInCookie);
      };
      _self[STR_CLEAR_AUTHENTICATED_USER_CONTEXT] = function() {
        appInsightsNew[_DYN_CONTEXT2].user[STR_CLEAR_AUTHENTICATED_USER_CONTEXT]();
      };
      _self._onerror = function(message, url, lineNumber, columnNumber, error) {
        appInsightsNew._onerror({ message, url, lineNumber, columnNumber, error });
      };
      _self.downloadAndSetup = function(config) {
        throwError("downloadAndSetup not implemented in web SKU");
      };
      _self[_DYN_UPDATE_SNIPPET_DEFIN0] = function(snippet2) {
        proxyAssign(snippet2, _this, function(name) {
          return name && arrIndexOf(_ignoreUpdateSnippetProperties2, name) === -1;
        });
      };
      _self[_DYN_LOAD_APP_INSIGHTS] = function() {
        if (_self[_DYN_CONFIG2]["iKey"]) {
          var originalTrackPageView_1 = _self[STR_TRACK_PAGE_VIEW];
          _self[STR_TRACK_PAGE_VIEW] = function(pagePath, properties, measurements) {
            originalTrackPageView_1.apply(_self, [null, pagePath, properties, measurements]);
          };
        }
        var legacyPageView = "logPageView";
        if (isFunction(_self[STR_SNIPPET][legacyPageView])) {
          _this[legacyPageView] = function(pagePath, properties, measurements) {
            _self[STR_TRACK_PAGE_VIEW](null, pagePath, properties, measurements);
          };
        }
        var legacyEvent = "logEvent";
        if (isFunction(_self[STR_SNIPPET][legacyEvent])) {
          _this[legacyEvent] = function(name, props, measurements) {
            _self[STR_TRACK_EVENT](name, props, measurements);
          };
        }
        return _this;
      };
      function _processLegacyInitializers(item) {
        item.tags[ProcessLegacy] = _queue;
        return item;
      }
    });
  }
  AppInsightsDeprecated2.__ieDyn = 1;
  return AppInsightsDeprecated2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-web@2.8.8/node_modules/@microsoft/applicationinsights-web/dist-esm/ApplicationInsightsContainer.js
var ApplicationInsightsContainer = function() {
  function ApplicationInsightsContainer2() {
  }
  ApplicationInsightsContainer2.getAppInsights = function(snippet, version) {
    var initialization = new Initialization(snippet);
    var legacyMode = version >= 2 ? false : true;
    _legacyCookieMgr();
    if (!legacyMode) {
      initialization[_DYN_UPDATE_SNIPPET_DEFIN0](snippet);
      initialization[_DYN_LOAD_APP_INSIGHTS](legacyMode);
      return initialization;
    } else {
      var legacy = new AppInsightsDeprecated(snippet, initialization);
      legacy[_DYN_UPDATE_SNIPPET_DEFIN0](snippet);
      initialization[_DYN_LOAD_APP_INSIGHTS](legacyMode);
      return legacy;
    }
  };
  return ApplicationInsightsContainer2;
}();
export {
  AppInsightsCore,
  AnalyticsPlugin as ApplicationAnalytics,
  Initialization as ApplicationInsights,
  ApplicationInsightsContainer,
  BaseCore,
  BaseTelemetryPlugin,
  CoreUtils,
  AjaxMonitor as DependenciesPlugin,
  DistributedTracingModes,
  Event2 as Event,
  Exception,
  LoggingSeverity,
  Metric,
  NotificationManager,
  PageView,
  PageViewPerformance,
  PerfEvent,
  PerfManager,
  PropertiesPlugin_default as PropertiesPlugin,
  RemoteDependencyData,
  Sender,
  SeverityLevel,
  Telemetry,
  Trace,
  Util,
  _InternalMessageId,
  doPerf
};
//# sourceMappingURL=@microsoft_applicationinsights-web.js.map
